export default {
  // layout
  LAYOUT: {
    header: {
      routes: {
        title: {
          ___caseList: 'Case List',
          ___phenoVarDBPopulationFrequencies: 'PhenoVarDB<br>Population Frequencies'
        },
        info: {
          ___userManual: 'User Manual',
          ___logOut: 'Log out'
        }
      },
      menu: {
        title: {
          ___userSetting: 'User setting'
        }
      }
    },
    footer: {
    },
    pageFooter: {
      ___compassBioinformatics: 'Compass Bioinformatics Inc.',
      ___cookie_policy: 'Cookie policy',
      ___privacy_policy: 'Privacy policy',
      ___alert: 'For Research Only'
    },
    uploading: {
      ___title: 'Uploading'
    }
  },
  // mixin
  MIXIN: {
    routeLoading: {
      ___noPermission: 'No permission'
    }
  },
  // page
  PAGE: {
    main: {
      ___forgetPassword: 'Forget Password？',
      ___or: 'OR',
      form: {
        title: {
          ___email: 'Account (E-mail)',
          ___password: 'Password'
        }
      }
    },
    forget: {
      ___info01: 'Please Enter the account (e-mail) which has been registered.',
      ___info02: 'We will send Reset Password letter to your email.',
      form: {
        title: {
          ___email: 'Account (E-mail)'
        },
        placeholder: {
          ___email: 'wiseTony@compassbioinfo.com'
        }
      }
    },
    reset: {
      ___info01: 'Here is reset password page,',
      ___info02: 'Please reset the password for account:',
      form: {
        title: {
          ___newPassword: 'New Password',
          ___confirmed: 'Confirm New Password'
        },
        errorTitle: {
          ___newPassword: 'Password',
          ___confirmed: 'Password'
        },
        placeholder: {
          ___newPassword: 'Please enter 14-100 characters',
          ___confirmed: 'Please enter your password again'
        },
        customValidate: {
          ___confirmed: 'Password confirmation is incorrect.'
        }
      }
    },
    active: {
      ___info01: 'Dear Manager, there is a new user sign up.',
      ___info02: 'Please review the user information and activate the account.',
      form: {
        title: {
          ___email: 'Account (E-mail)',
          ___firstName: 'First Name',
          ___lastName: 'Last Name',
          ___country: 'Country',
          ___organization: 'Service Unit',
          ___appliedDate: 'Apply Date'
        }
      }
    },
    deviceAlert: {
      ___info01: 'It is recommended to log in with a computer or laptop,',
      ___info02: 'or may affect your operating experience.'
    },
    datasetAccess: {
      form: {
        title: {
          ___accessKey: 'Access Key'
        },
        placeholder: {
          ___accessKey: 'Please enter 16 digitals access key'
        }
      }
    },
    genePanel: {
      ___title: 'Gene Panel Search',
      geneTag: {
        ___placeholder: 'Type disease or gene panel'
      },
      introduction: {
        collapse: {
          ___content01: 'If you don\'t know how to begin, here are…'
        },
        display: {
          ___content01: 'If you don\'t know how to begin, here are',
          ___content02: 'some phenotypes for hereditary diseases:',
          ___content03: 'e. g. Marfan syndrome、Leber hereditary optic neuropathy、Fabry disease、Epilepsy、Noonan and RASopathies…'
        }
      }
    },
    phenotypeDisease: {
      ___title01: 'Similarity between',
      ___title02: 'Phenotypes and Diseases',
      ___alert01: 'The results are only for reference,',
      ___alert02: 'not for diagnosis.',
      ___selectedTitle: 'Selected',
      ___selectedRemind: 'you can discard a phenotype with unselect the checkbox.',
      ___resultPhenotypeTitle: 'Imported Phenotypes',
      ___resultTableTitle: 'Results',
      phenotypeTag: {
        ___placeholder: 'Type phenotypes'
      },
      introduction: {
        collapse: {
          ___content01: 'If you don\'t know how to begin, here are…'
        },
        display: {
          ___content01: 'If you don\'t know how to begin, here are',
          ___content02: 'some phenotypes for hereditary diseases:',
          ___content03: 'e. g. Global developmental delay、Short stature、 Hypotonia、 Nystagmus、Hearing impairment、Intellectual disability、Microcephaly…',
          ___content04: 'But <span class="alert">do NOT</span> over 10 terms.',
          ___content05: 'You can also find suitable phenotype terms on <a href="https://hpo.jax.org/app/" target="_blank">HPO website</a>.'
        }
      },
      table: {
        title: {
          ___index: 'Rk',
          ___omimID: 'OMIM ID',
          ___name: 'Disease Name'
        }
      },
      uploading: {
        ___pleaseWait: 'Please do not leave the page and wait for a moment'
      }
    },
    coverageRate: {
      ___title: 'Coverage Rate Search Tool',
      ___searchPlaceholder: 'Resfeq id (eg: NM_000059.4) or gene symbol (eg: BRCA1)',
      table: {
        title: {
          ___refseqID: 'Refseq id',
          ___symbol: 'Symbol',
          ___region: 'Region',
          ___libraryKit: 'Library kit',
          ___10XPctMeanCov: '10X pct mean cov',
          ___20XPctMeanCov: '20X pct mean cov'
        }
      }
    },
    register: {
      ___info01: 'Welcome to inheriNext, an AI Genetic Variants Screening System.',
      ___info02: 'please fill in the information and agree to the user terms to register,',
      ___info03: 'A specialist will activate the account for you, please be patient.',
      ___agreementCheckTitle: 'I have carefully read and fully agree to the Terms and <a class="link" href="{link}" target="_blank">Privacy Policy</a>.',
      ___agreementDownloadPDFTitle: 'Download Terms of Use (Traditional Chinese)',
      ___agreementContent: `<span style="font-size:1.5rem; font-weight:500;">Welcome to InheriNext® Edge</span>
Welcome to the InheriNext® Edge platform developed by Compass Bioinformatics Inc. Your use of InheriNext® Edge infers your agreement with our Terms and Conditions. If you have any problems or concerns with the Terms and Conditions as described below, please stop using InheriNext® Edge.

<span style="font-size:1rem; font-weight:500;">The Application of InheriNext® Edge</span>
InheriNext® Edge provides the analysis of genetic data for scientific users. InheriNext® Edge does not contain any diagnostic or medical advice. InheriNext® Edge has no other application except as described above.

<span style="font-size:1rem; font-weight:500;">The Data Ownership Statement</span>
The ownership of all data uploaded into InheriNext® Edge is fully retained by the user. Compass Bioinformatics Inc only uses the uploaded data to deliver a report. Compass Bioinformatics Inc. uses summarized (aggregated) data from these reports to improve the accuracy of its methods. Data is never sold or transferred to a third party.

<span style="font-size:1rem; font-weight:500;">Personal Information Protection</span>
The data uploaded into InheriNext® Edge is stored securely and is protected consistent with our privacy policy. Registered users will be notified by email of system updates, maintenance, new versions. Users can unsubscribe from release notifications via the email's unsubscribe button. Personal information is not shared with or sold to third parties.

<span style="font-size:1rem; font-weight:500;">Suspend and Stop the Service</span>
You agree that Compass Bioinformatics Inc. has the right to suspend or stop the overall or partial functions of InheriNext® Edge for any reason. Refunds will only be processed for the incomplete service. Compass Bioinformatics Inc assumes no additional service responsibilities.

<span style="font-size:1rem; font-weight:500;">Warranty and Disclaimer</span>
You agree that the knowledge bases used by InheriNext® Edge are scientifically plausible, but that they may not be 100% accurate or complete. You agree to apply independent thought when reading the results from InheriNext® Edge's analyses, and that any insights so derived are entirely from yourself.

<span style="font-size:1rem; font-weight:500;">Optimization</span>
You agree that InheriNext® Edge may be optimized through your usage, but that you are not entitled to any ownership of InheriNext® Edge, partial or otherwise.

<span style="font-size:1rem; font-weight:500;">Local Laws Application</span>
You confirm that you will abide by the Terms and Conditions of InheriNext® Edge, and that you are also in compliance with your local laws.`,
      form: {
        title: {
          ___email: 'Account (E-mail)',
          ___verification: 'Verification',
          ___firstName: 'First Name',
          ___lastName: 'Last Name',
          ___country: 'Country',
          ___countryCode: 'Phone',
          ___organization: 'Organization',
          ___division: 'Division or subunit',
          ___managerID: 'Manager Code',
          ___password: 'New Password',
          ___confirmed: 'Confirm New Password'
        },
        placeholder: {
          ___email: 'wiseTony@compassbioinfo.com',
          ___verification: '6 digits code',
          ___firstName: 'John',
          ___lastName: 'William',
          ___country: 'Taiwan',
          ___countryCode: '+886',
          ___phone: 'Your phone number',
          ___organization: 'Compass Bioinfomatics Inc.',
          ___division: 'Clinical research department',
          ___managerID: '3 digits code',
          ___password: 'Please enter 14-100 characters',
          ___confirmed: 'Please enter your password again'
        },
        errorTitle: {
          ___email: 'account (E-mail)',
          ___password: 'Password',
          ___confirmed: 'Password'
        },
        customValidate: {
          ___country: 'The country name format is wrong. Please check it.',
          ___countryCode: 'The country code doesn\'t exist',
          ___confirmed: 'Password confirmation is incorrect.',
          ___verificationCode: 'Verification code is wrong.'
        }
      }
    },
    user: {
      ___avatarTitle: 'Avatar',
      tab: {
        ___info: 'Basic information',
        ___password: 'Password setting',
        ___license: 'License manager'
      },
      form: {
        title: {
          ___email: 'Account (E-mail)',
          ___firstName: 'First Name',
          ___lastName: 'Last Name',
          ___country: 'Country ',
          ___countryCode: 'Phone',
          ___manager: 'Supported manager',
          ___organization: 'Organization',
          ___division: 'Division or subunit',
          ___emailVerification: 'E-mail verification',
          ___originalPassword: 'Old Password',
          ___password: 'New Password',
          ___confirmed: 'Confirm New Password'
        },
        placeholder: {
          ___firstName: 'John',
          ___lastName: 'William',
          ___country: 'Taiwan',
          ___countryCode: '+886',
          ___phone: 'Your phone number',
          ___organization: 'Compass Bioinfomatics Inc.',
          ___division: 'Clinical research department',
          ___originalPassword: 'Please enter 14-100 characters',
          ___password: 'Please enter 14-100 characters',
          ___confirmed: 'Please enter your password again'
        },
        errorTitle: {
          ___originalPassword: 'Password',
          ___password: 'Password',
          ___confirmed: 'Password'
        },
        customValidate: {
          ___country: 'The country name format is wrong. Please check it.',
          ___countryCode: 'The country code doesn\'t exist',
          ___confirmed: 'Password confirmation is incorrect.',
          ___verificationCode: 'Verification code is wrong.'
        }
      }
    },
    systemInfo: {
      tab: {
        ___database: 'Database info.'
      },
      table: {
        title: {
          ___title: 'Name',
          ___version: 'Version'
        }
      }
    },
    panel: {
      tab: {
        ___phenotype: 'Phenotype set',
        ___gene: 'Gene Panel'
      }
    },
    config: {
      tab: {
        ___filter: 'Config filter'
      }
    },
    workgroup: {
      tab: {
        ___case: 'Case'
      }
    },
    genomeBrowser: {
      table: {
        title: {
          ___position: 'Position (HG38)',
          ___location: 'Exon/Intron location',
          ___HGVSc: 'HGVSc',
          ___HGVSp: 'HGVSp'
        }
      }
    },
    caseBatchUpload: {
      form: {
        title: {
          ___owner: 'Owner'
        }
      },
      alert: {
        ___content: 'If no edits are made <b>within 5 days</b>, all records for this batch upload,<br>including the VCF and sample sheet file, will be deleted automatically.',
        ___date: '<b>Created at:</b> {create} | <b>Modified at:</b> {update}'
      }
    },
    caseDetail: {
      title: {
        ___deleted: 'DEL'
      },
      project: {
        title: {
          alert: {
            ___sexDifferent: 'The sex info of the analysis is different from the case. You can re-analysis by editing the parameters of the analysis.'
          }
        },
        card: {
          title: {
            ___modified: 'Modified'
          }
        },
        info: {
          title: {
            ___status: 'Status',
            ___created: 'Created',
            ___modified: 'Modified'
          }
        },
        icon: {
          title: {
            ___delete: 'Delete'
          }
        },
        detail: {
          intractablePanel: {
            ___title: 'D006-4 遺伝学的検査疾患名',
            ___less: 'less',
            ___more: '{count} items more'
          },
          phenotype: {
            ___title: 'Phenotype',
            ___less: 'less',
            ___more: '{count} items more'
          },
          genePanel: {
            ___title: 'Gene / Disease panel',
            ___infoTitle: 'Mendelian',
            ___info: 'If the switch is turned on, the selected loci conform to Mendelian inheritance. The reasons for filtering loci that don\'t fit Mendelian inheritance are: 1.The technical limitations of NGS may cause the misjudgment of inheritance pattern. 2.Some specific diseases cause symptoms even the loci don\'t fit Mendelian inheritance.',
            ___less: 'less',
            ___more: '{count} items more'
          },
          mendelian: {
            ___title: 'Mendelian'
          },
          afThreshold: {
            ___title: 'AF threshold for MOI',
            ___info: 'The allele frequency threshold depends on the prevalence of diseases and should be adjusted accordingly. The value should be > 0 and ≤ 1. If you want to edit the values of threshold, Click edit button nearby phenotype.',
            item: {
              title: {
                ___ad: 'AD',
                ___compHet: 'Comp. het.',
                ___ar: 'AR',
                ___exclLQ: 'Excl. LQ'
              }
            }
          },
          phenotypeVariant: {
            ___title: 'Phenotype & Variant score thresholds',
            ___info: 'Phenotype scores were calculated using semantic similarity based on phenotypes user provided. Variant scores were calculated by multiple prediction scores (e.g SIFT, CADD) and population allele frequencies. If you want to edit the values of threshold, click the edit button nearby phenotype.',
            item: {
              title: {
                ___phenotypeScore: 'Phenotype score',
                ___variantScore: 'Variant score'
              }
            }
          }
        }
      },
      top: {
        icon: {
          title: {
            ___file: 'Files',
            ___analysisVersion: 'Analysis Version',
            ___qc: 'Quality Control',
            ___delete: 'Delete'
          }
        }
      },
      caseInfo: {
        title: {
          ___owner: 'Owner',
          ___subjectName: 'Name',
          ___sex: 'Sex',
          ___birthYear: 'Year of birth',
          ___population: 'Population',
          ___note: 'Note',
          ___workgroup_name: 'Workgroup',
          ___workgroup_stage: '- Stage',
          ___workgroup_due_date: '- Due date',
          ___workgroup_assignee: '- Assignee'
        },
        empty: {
          ___birthYear: 'Unknown'
        }
      },
      tab: {
        data: {
          ___defaultTitle: 'default',
          examinationIntractableDisease: {
            ___title: '保険検査と指定難病',
            subTab: {
              intractableDiseaseResults: {
                ___title: 'D006-4の結果'
              },
              designatedIntractableDiseaseResults: {
                ___title: '指定難病の結果'
              }
            }
          },
          diagnosticTest: {
            ___title: 'Candidate list',
            subTab: {
              phenotypeResults: {
                ___title: 'Phenotype results'
              },
              genePanelResults: {
                ___title: 'Gene Panel results'
              },
              repeatResults: {
                ___title: 'repeat results'
              }
            }
          },
          proactiveTest: {
            ___title: 'Proactive test',
            subTab: {
              pathogenicVariants: {
                ___title: 'Pathogenic Variants'
              },
              nullVariants: {
                ___title: 'Null Variants'
              },
              carrier: {
                ___title: 'Carrier'
              },
              incidentalFindings: {
                ___title: 'Incidental findings'
              }
            }
          },
          filter: {
            ___title: 'Filter'
          },
          monitor: {
            ___title: 'Monitor'
          },
          report: {
            ___title: 'Report'
          }
        },
        info: {
          ___limit: 'The records have reached the limit of 200. Please be aware that some of the data is not available.'
        }
      },
      displayView: {
        title: {
          ___SNV: 'SNV',
          ___SV: 'SV',
          ___STR: 'STR'
        }
      },
      edit: {
        ___info: 'You can edit the case and analysis information before you finish to upload NGS data (FASTQ or VCF).'
      },
      modal: {
        content: {
          ___delete: 'Once you delete this case, the case\'s results will be removed from InheriNext. Do you want to delete this case?',
          ___user: 'This case has been used for the dataset build of {dataset} in the PhenoVarDB. Please delete the dataset mentioned above before you delete the case. | This case has been used for the datasets build of {dataset} in the PhenoVarDB. Please delete the datasets mentioned above before you delete the case.',
          ___admin: 'This case has been used for the dataset build of {dataset} in the PhenoVarDB. The accessibility of datasets shown above will be affected upon you delete this sample. Do you want to delete this case? | This case has been used for the datasets build of {dataset} in the PhenoVarDB. The accessibility of datasets shown above will be affected upon you delete this sample. Do you want to delete this case?',
          ___truelyDelete: 'All the files and information of this case will be PERMANENTLY removed. Do you want to continue?',
          ___truelyAdmin: 'This case has been used for the dataset build of {dataset} in the PhenoVarDB. The accessibility of datasets shown above will be affected upon you delete this sample. Do you want to delete this case? | This case has been used for the datasets build of {dataset} in the PhenoVarDB. The accessibility of datasets shown above will be affected upon you delete this sample. Do you want to delete this case?',
          ___restartPipeline: '<span style="color:#FA3D3D">Please make sure the error has been corrected, otherwise the analysis may fail again.</span>',
          ___deleteProject: '<span style="color:#FF414D">Once you delete the analysis, associated results will be removed from InheriNext. Do you want to delete it?</span>'
        }
      }
    },
    caseList: {
      tab: {
        title: {
          ___single: 'Single'
        }
      }
    },
    datasetDetail: {
      top: {
        icon: {
          content: {
            ___adminAnnotation: 'Select for annotation of admin.',
            ___annotation: 'Select for annotation.',
            ___unchiveDataset: 'Unchive the dataset',
            ___archiveDataset: 'Archive the dataset'
          }
        }
      },
      info: {
        title: {
          ___create: 'Create',
          ___modified: 'Modified',
          ___sampleSize: 'Sample size',
          ___externalData: 'External data',
          ___owner: 'Owner',
          ___description: 'Description',
          ___tags: 'Tags',
          ___sharing: 'Sharing',
          ___users: 'Users',
          ___datasetURL: 'Dataset URL',
          ___accessKey: 'Access Key'
        },
        content: {
          externalData: {
            ___yes: 'Yes',
            ___no: 'No'
          },
          sharing: {
            ___community: 'Community',
            ___notAvailable: 'Not available'
          },
          users: {
            ___users: '{count} user | {count} users'
          }
        },
        icon: {
          title: {
            ___datasetURL: 'Copy'
          }
        }
      },
      tab: {
        title: {
          ___summary: 'Summary',
          ___samplesList: 'Samples list'
        }
      },
      modal: {
        content: {
          ___deleteDataset: '<span style="color:#FF414D">If you delete this dataset, it will be removed permanently.<br>Do you want to delete the dataset?</span>',
          ___setDatasetAnnotation01: 'Select this dataset for the annotation of PhenoVarDB {type} in Population Databases of your case.',
          ___setDatasetAnnotation02: 'Please make sure you re-analyse the case to update the annotation of PhenoVarDB {type}.',
          ___setDatasetAnnotation03: '<span>{dataset} dataset has been selected for annotation.<br>Would you like to select this dataset?</span>'
        }
      }
    },
    datasetList: {
      ___roleFilterTitle: 'Role',
      ___roleFilterPlaceholder: 'all',
      ___sortTitle: 'Sort by',
      ___searchPlaceholder: 'Type Keywords of dataset to search, e.g., breast cancer.',
      sortOption: {
        default: {
          title: {
            ___name: 'Dataset name',
            ___createdAt: 'Created date',
            ___updatedAt: 'Modified date',
            ___sampleSize: 'Sample size',
            ___externalDataIncluded: 'External data',
            ___state: 'Status'
          }
        },
        community: {
          title: {
            ___name: 'Dataset name',
            ___createdAt: 'Created date',
            ___updatedAt: 'Modified date',
            ___sampleSize: 'Sample size',
            ___communityPermission: 'Permission'
          }
        }
      },
      tab: {
        title: {
          ___default: 'My Dataset',
          ___community: 'Community'
        }
      },
      subTab: {
        default: {
        },
        community: {
          title: {
            ___default: 'Community datasets',
            ___sharedWithMe: 'Shared with me',
            ___myShares: 'My shares'
          }
        }
      }
    },
    common: {
      accountTab: {
        ___user: 'Account',
        ___workgroup: 'Workgroup',
        ___panel: 'Panel',
        ___config: 'Config',
        ___systemInfo: 'System Info.'
      }
    }
  },
  // component
  COMPONENT: {
    case: {
      base: {
        customForm: {
          affected: {
            ___title: 'Affected'
          },
          reportPhenovardb: {
            ___off: 'Off',
            ___on: 'On'
          }
        },
        analysis: {
          ___title: 'Phenotype prioritization',
          ___familyTitle: 'Family Analysis',
          panel: {
            ___title: 'Phenotype Panel',
            ___empty: 'You don\'t have any panel yet. you can create a panel here'
          },
          phenotype: {
            ___selectedTitle: 'Selected',
            phenotypeTag: {
              ___placeholder: 'Phenotype (eg: Dyspnea) or Disease (eg: Breast Cancer)'
            }
          },
          gene: {
            ___title: 'Gene filter',
            ___selectedTitle: 'Selected',
            geneTag: {
              ___placeholder: 'Gene Panel (eg: Additional findings health related)'
            }
          },
          genePanel: {
            ___title: 'Gene / Disease panel'
          },
          alleleFrequencyThreshold: {
            ___title: 'Allele frequency threshold for inheritance modes',
            ___info: 'The allele frequency threshold depends on the prevalence of diseases and should be adjusted accordingly. The value should be > 0 and ≤ 1.'
          },
          scoreThreshold: {
            ___title: 'Score threshold for phenotype/gene panel selection',
            ___info: 'Phenotype scores were calculated using semantic similarity based on phenotypes user provided. Variant scores were calculated by multiple prediction scores (e.g SIFT, CADD) and population allele frequencies. The value should be ≥ 0.6 and ≤ 1'
          },
          familyAnalysis: {
            ___title: 'Family Members',
            alert: {
              ___vcf: 'The format of vcf file does NOT support for the family analysis.'
            },
            option: {
              title: {
                ___excludeVariant: 'Exclude variants by family segregation algorithm'
              }
            }
          }
        },
        file: {
          ___afterAlert: 'If you don\'t have data yet, you can upload later.',
          ___cloudTitle: 'Upload from google bucket',
          vcf: {
            ___title: 'VCF Dataset',
            file: {
              ___snvTitle: 'SNV VCF file',
              ___svTitle: 'SV VCF file',
              ___strTitle: 'ExpansionHunter (STR) VCF',
              ___svInfo: 'Multiple SV VCF files are supported (Maximum {count}).',
              ___source01: 'Currently, we only support genome build version GRCh38/hg38.',
              ___source02: 'Please make sure a concordant genome build version of vcf file is uploaded.'

            }
          },
          fastq: {
            ___title: 'FASTQ Dataset',
            file: {
              ___title: 'Set{set}-Fastq-{read}'
            }
          },
          alert: {
            ___content: '<b>Notice!</b>  We only support genome build version GRCh38/hg38. Ensure  a concordant genome build version of VCF file is uploaded.'
          },
          pipeline: {
            title: {
              ___single: 'Single-end',
              ___paired: 'Paired-end'
            }
          }
        },
        option: {
          sex: {
            title: {
              ___male: 'Male',
              ___female: 'Female',
              ___unknown: 'Unknown'
            }
          },
          popuplation: {
            title: {
              ___AfricanAfricanAmerican: 'African/African-American',
              ___LatinoAdmixedAmerican: 'Latino/Admixed American',
              ___AshkenaziJewish: 'Ashkenazi Jewish',
              ___EastAsian: 'East Asian',
              ___Koreans: 'Koreans',
              ___Japanese: 'Japanese',
              ___OtherEastAsian: 'Other East Asian',
              ___Finnish: 'Finnish',
              ___NonFinnishEuropean: 'Non-Finnish European',
              ___Bulgarian: 'Bulgarian',
              ___Estonian: 'Estonian',
              ___NorthWesternEuropean: 'North-Western European',
              ___SouthernEuropean: 'Southern European',
              ___Swedish: 'Swedish',
              ___OthernonFinnishEuropean: 'Other non-Finnish European',
              ___SouthAsian: 'South Asian',
              ___Other: 'Other'
            }
          }
        },
        form: {
          case: {
            title: {
              ___owner: 'Owner',
              ___caseID: 'Case ID',
              ___affected: 'Sample type',
              ___subjectName: 'Name',
              ___sex: 'Sex',
              ___birthYear: 'Year of Birth',
              ___population: 'Population',
              ___note: 'Note'
            },
            placeholder: {
              ___caseID: 'Case ID',
              ___subjectName: 'John',
              ___sex: 'Sex',
              ___birthYear: 'Year',
              ___population: 'Population',
              ___note: 'Ex: Compassbioinfomatics. Inc'
            },
            format: {
              affected: {
                ___true: 'Affected',
                ___false: 'Unaffected'
              }
            },
            option: {
              birthYear: {
                ___unknown: 'Unknown'
              }
            }
          },
          analysis: {
            title: {
              ___name: 'Analysis Name',
              ___note: 'Analysis Note',
              ___report: 'Report to PhenoVarDB'
            },
            placeholder: {
              ___name: 'breast cancer panel',
              ___note: 'Ex: Compassbioinfomatics. Inc'
            }
          },
          alleleFrequencyThreshold: {
            title: {
              ___ad_cutoff: 'Autosomal dominant (AD)',
              ___ar_cutoff: 'Autosomal recessive (AR)',
              ___comp_het_cutoff: 'Compound heterozygosity',
              ___exclude_low_quality_variants: 'Exclude LQ variants',
              ___enable_clinvar_benign_filter: 'Lower priority for known benign variants'
            },
            errorTitle: {
              ___ad_cutoff: 'AD',
              ___ar_cutoff: 'AR'
            },
            placeholder: {
              ___ad_cutoff: '0.001',
              ___ar_cutoff: '0.05',
              ___comp_het_cutoff: '0.05'
            }
          },
          scoreThreshold: {
            title: {
              ___phenotype_score_cutoff: 'Phenotype score',
              ___variant_score_cutoff: 'Variant score'
            },
            placeholder: {
              ___phenotype_score_cutoff: '0.3',
              ___variant_score_cutoff: '0.7'
            }
          },
          pipeline: {
            title: {
              ___omics_name: 'Pipeline'
            },
            errorTitle: {
              ___omics_name: 'Omics',
              ___pipeline_name: 'Pipeline',
              ___library_type_name: 'Library type'
            },
            placeholder: {
              ___omics_name: 'Omics',
              ___pipeline_name: 'Types, eg: WGS',
              ___library_type_name: 'Library kit eg: Roche KAPA HyperExome kit'
            }
          }
        }
      },
      baseFamilyCase: {
        ___searchPlaceholder: 'Case ID (e.g., Case1)',
        table: {
          title: {
            ___case_id: 'Case ID',
            ___type: 'Sample type',
            ___relation: 'Relation'
          },
          option: {
            type: {
              title: {
                ___Affected: 'Affected',
                ___Unaffected: 'Unaffected'
              }
            },
            relation: {
              ___placeholder: 'Select a relation'
            }
          }
        }
      },
      genotypeIcon: {
        altMessage: {
          relation: {
            ___father: 'Father',
            ___mother: 'Mother',
            ___proband: 'Proband'
          },
          result: {
            ___ref: 'ref',
            ___homo: 'homo',
            ___hemi: 'hemi',
            ___ref_hemi: 'ref(hemi)',
            ___het: 'het',
            ___unknown: 'unknown'
          }
        }
      },
      diseaseIcon: {
        ___text01: 'It directly maps to the condition-<br>associated HPO.',
        ___text02: 'It indirectly maps to the condition-associated HPO.',
        ___text03: 'A path of similarity shows a connection from the provided HPO term to the condition-associated HPO term through <b>{length}</b> neighborhood(s).'
      },
      errorMessage: {
        ___uploading: 'Data is uploading…',
        ___analyzing: 'Data Analysis is processing…',
        ___failed01: 'An unpredictable problem occurred,',
        ___failed02: 'we are excluding this problem right now.',
        ___failed03: 'An unpredictable problem occurred:'
      },
      intractableDisease: {
        select: {
          ___title: 'D006-4 遺伝学的検査'
        },
        switch: {
          ___title: '指定難病分析',
          switchButton: {
            ___off: 'オフ',
            ___on: 'オン'
          }
        },
        selectResult: {
          ___title: 'selected'
        }
      },
      mastermindFilterTable: {
        table: {
          title: {
            ___report: 'REPT',
            ___classification: 'Classification',
            ___variantIdentifiers: 'Variant identifiers',
            ___publications: 'Publications'
          },
          value: {
            ___publications: '{count} Publication | {count} Publications',
            ___empty: 'Mastermind is locked. Please unlock to view results.'
          }
        }
      },
      mastermindPublicationTable: {
        table: {
          title: {
            ___no: 'No.',
            ___details: 'Details',
            ___PMID: 'PMID'
          },
          info: {
            details: {
              ___open: '(detail)',
              ___hide: 'Hide'
            }
          }
        },
        page: {
          ___total: 'Total {total} results',
          ___display: '{display} results per page'
        }
      }
    },
    caseBatchUpload: {
      base: {
        modal: {
          content: {
            ___deleteSet: '<span style="color:#FA3D3D">This action will permanently delete all upload records. Are you sure you want to delete the batch uploads?</span>',
            ___confirmSuccess: '<span style="color:#003679"><b>All {count} samples are ready.</b> Do you want to submit?</span>',
            ___confirmFailed: '<span style="color:#FA3D3D"><b>{count} samples are not ready.</b> If you continue, these unready samples will not be created. Do you want to submit?</span>'
          }
        }
      },
      sheetUpload: {
        form: {
          ___title: 'Sample sheet',
          ___info: '<span>template</span>'
        },
        result: {
          ___title: 'Sample sheet check',
          group: {
            title: {
              ___error: '{count} error | {count} error | {count} errors'
            },
            error: {
              ___invalidFilesize: 'File too large'
            }
          }
        }
      },
      fileUpload: {
        form: {
          ___title: 'VCF data set',
          upload: {
            ___title: 'Drag the files here',
            ___content: 'Or <span>select files</span> from you dervice.'
          }
        },
        result: {
          ___title: 'Upload files',
          ___info: 'Finished: <b>{upload}</b>/{total}',
          group: {
            title: {
              ___uploading: 'Uploading {info}',
              ___finished: 'Finished {info}',
              ___failed: 'Failed & error {info}'
            }
          },
          file: {
            info: {
              ___uploading: '(<span class=uploading>waiting</span>)',
              ___pending: '(<span class=uploading>pending</span>)',
              ___finished: '(<span class=finished>complete</span>)',
              ___matched: '(<span class=finished>Filename matched</span>)',
              error: {
                ___invalidFormat: 'Invalid file format',
                ___duplicatedFilename: 'Duplicated filename',
                ___invalidFilesize: 'File too large'
              }
            }
          }
        }
      },
      sheetResult: {
        ___title: 'Confirm uploads',
        ___info: '(<span>{count}/{total} matched</span>)',
        search: {
          ___placeholder: 'Type Keywords, e.g., Case ID, sex… to search'
        },
        table: {
          title: {
            ___case_id: 'Case ID',
            ___sampleType: 'Sample Type',
            ___sex: 'Sex',
            ___analysisName: 'Analysis Name',
            ___phenotype: 'Phenotype',
            ___snvVCF: 'SNV VCF',
            ___svVCF: 'SV VCF',
            ___strVCF: 'STR VCF',
            ___delete: 'DEL',
            info: {
              ___phenotype: 'If you want to edit the phenotype, please update the sample sheet and upload again.'
            }
          },
          display: {
            sampleType: {
              ___true: 'Affected',
              ___false: 'Unaffected'
            },
            sex: {
              ___Male: 'M',
              ___Female: 'F',
              ___Unknown: 'U'
            }
          },
          content: {
            info: {
              ___phenotype: 'Not found in the HPO database.'
            },
            empty: {
              ___phenotype: 'No phenotype',
              ___file: 'No File'
            }
          }
        },
        page: {
          ___total: 'Total {total} results',
          ___display: '{display} results per page'
        }
      }
    },
    caseDetail: {
      analysisVersionTable: {
        table: {
          title: {
            ___category: 'Category',
            ___name: 'Name',
            ___version: 'Version'
          }
        }
      },
      filter: {
        ___empty: '0 Item',
        table: {
          title: {
            ___CHROM: 'Chr',
            ___POS: 'Pos',
            ___REF: 'Ref / Alt',
            ___dbSNP_ID: 'rsID',
            ___Consequence: 'Consequences',
            ___GT: 'Genotype',
            ___SYMBOL: 'Symbol',
            ___HGVSc: 'HGVSc',
            ___HGVSp: 'HGVSp'
          }
        },
        modal: {
          content: {
            ___retryAlert: '<span>Job failed. Would you like to resend the job?</span>'
          }
        }
      },
      dataList: {
        page: {
          ___total: 'Total {total} results',
          ___display: '{display} results per page'
        },
        error: {
          ___text: 'No likely disease-causative variants were found.',
          ___empty: 'No data.'
        }
      },
      geneData: {
        table: {
          ___variantAlert: 'Variant phasing has not been considered yet.',
          icon: {
            monitor: {
              ___title01: 'add to monitor',
              ___title02: 'remove from monitor'
            },
            report: {
              ___title01: 'add to report',
              ___title02: 'remove from report'
            }
          },
          title: {
            ___position: 'Position<br>(HG38)',
            ___rank: 'Exon/Intron<br>location',
            ___HGVSm: 'HGVSm',
            ___HGVSc: 'HGVSc',
            ___HGVSp: 'HGVSp',
            ___Zygosity: 'Zygosity',
            ___HeteroplasmyLevel: 'Heteroplasmy<br>Level (%)',
            ___Consequence: 'Consequence',
            ___Prediction: 'Prediction<br>scores',
            ___AlleleFrequency: 'Allele Frequency',
            ___Homoplasmy: 'Homoplasmy<br>EAS AF',
            ___Heteroplasmy: 'Heteroplasmy<br>EAS AF',
            ___variantDatabase: 'Variant<br>Databases',
            ___ACMG: 'ACMG',
            ___rsID: 'rs ID',
            ___parentalOrigin: 'Parental origin'
          },
          link: {
            position: {
              ___UCSC: 'UCSC',
              ___Ensembl: 'Ensembl',
              ___Genomebrowser: 'Genome browser'
            }
          }
        },
        externalLink: {
          title: {
            ___GHR: 'GHR',
            ___NCBI_Gene: 'NCBI Gene',
            ___OMIM: 'OMIM',
            ___UniProt: 'UniProt',
            ___HPO: 'HPO',
            ___Orphanet: 'Orphanet'
          }
        },
        intractableDiseaseLink: {
          title: {
            ___center: '難病情報センター',
            ___other: '他の関連情報',
            ___nando: 'NanbyoData 難病データ'
          }
        },
        condition: {
          ___title: 'Conditions',
          ___alert01: 'The condition recommended for reporting of incidental findings.',
          ___less: 'less',
          ___more: '{count} items more'
        },
        disease: {
          ___title: 'Phenotype network of selected condition',
          ___less: 'less',
          ___more: '{count} items more'
        }
      },
      genePreviewDisplayForm: {
        mainFormOptions: {
          title: {
            ___1st: '1st Column',
            ___2nd: '2nd Column'
          }
        }
      },
      geneClinvarData: {
        ___clinvarStatisticTitle: 'ClinVar gene statistics',
        table: {
          clinvar: {
            ___title: 'ClinVar',
            title: {
              ___interpretation: 'Interpretation',
              ___reviewStatus: 'Review status',
              ___condition: 'Condition',
              ___conflicts: 'Conflicts'
            }
          }
        }
      },
      geneMastermindData: {
        ___lockAlert: 'Mastermind is locked. Please unlock to view results.',
        table: {
          mastermind: {
            ___title: 'Mastermind',
            title: {
              ___report: 'REPT',
              ___classification: 'Classification',
              ___variantIdentifiers: 'Variant identifiers',
              ___publications: 'Publications'
            },
            value: {
              ___publications: '{count} Publication | {count} Publications'
            }
          },
          publication: {
            ___title: 'Publication details of <b>Report {count}</b> on <b>{variant}</b>'
          }
        },
        modal: {
          content: {
            ___unlockReanalyze: 'Once you apply the annotation, the system will reanalyze this case and update the results with <b>Mastermind annotation</b>. Would you like to apply to this analysis?',
            ___unlockReanalyzeForOwner: 'Once you apply the annotation, the system will <span class=alert>consume your license quota</span> and reanalyze this case and update the results with <b>Mastermind annotation for {owner}</b>. Would you like to apply to this analysis?',
            ___unlockReload: 'Once you apply the annotation, the page will reload, and you need to reopen this page to see the updated results with <b>Mastermind annotation</b>. Would you like to apply to this analysis?',
            ___unlockReloadForOwner: 'Once you apply the annotation, the system will <span class=alert>consume your license quota</span> <b>for {owner}</b>, and the page will reload. You need to reopen the page to see the updated results with <b>Mastermind annotation</b>. Would you like to apply to this analysis?'
          }
        }
      },
      geneMitomapData: {
        table: {
          mitomap: {
            ___title: 'MITOMAP',
            title: {
              ___af: 'AF',
              ___heteroplasmy: 'Heteroplasmy',
              ___homoplasmy: 'Homoplasmy',
              ___diseaseStatus: 'Disease Status',
              ___disease: 'Disease',
              ___pubmedIDs: 'Pubmed IDs'
            }
          }
        }
      },
      regionData: {
        ___geneTitle: 'Overlapping gene(s)',
        table: {
          icon: {
            monitor: {
              ___title01: 'add to monitor',
              ___title02: 'remove from monitor'
            },
            report: {
              ___title01: 'add to report',
              ___title02: 'remove from report'
            }
          },
          title: {
            ___Cytoband: 'Cytoband',
            ___Length: 'Length',
            ___Zygosity: 'Zygosity',
            ___dbVar: 'dbVar',
            ___DECIPHER: 'DECIPHER',
            ___AF: 'AF',
            ___SV_Caller: 'SV Caller',
            ___ACMG_SV: 'ACMG SV'
          }
        },
        externalLink: {
          title: {
            ___DGV: 'DGV',
            ___DECIPHER: 'DECIPHER',
            ___GHR: 'GHR',
            ___OMIM: 'OMIM',
            ___HPO: 'HPO',
            ___Orphanet: 'Orphanet'
          }
        },
        condition: {
          // ___title: 'Conditions',
          ___title: 'Top 5 genes & Gene Associated Conditions',
          ___emptyText: 'Click the <a class=link>overlapping gene(s)</a> for conditions of every gene',
          ___alert01: 'The condition recommended for reporting of incidental findings.',
          ___less: 'less',
          ___more: '{count} items more',
          inheritance: {
            ___info: 'and {count} other condition | and {count} other conditions'
          }
        },
        disease: {
          ___title: 'Phenotype network of DECIPHER',
          ___less: 'less',
          ___more: '{count} items more'
        }
      },
      regionOverlappingGeneData: {
        table: {
          title: {
            ___Overlap_region: 'Overlap region',
            ___Dosage_sensitivity: 'Dosage sensitivity',
            ___pLI: 'pLI',
            ___LOEUF: 'LOEUF'
          },
          content: {
            Dosage_sensitivity: {
              ___Haplo: 'Haplo',
              ___Triplo: 'Triplo'
            },
            pLI: {
              ___GenomAD: 'GenomAD',
              ___ExAC: 'ExAC'
            }
          }
        },
        externalLink: {
          title: {
            ___GHR: 'GHR',
            ___NCBI_Gene: 'NCBI Gene',
            ___OMIM: 'OMIM',
            ___UniProt: 'UniProt',
            ___HPO: 'HPO',
            ___Orphanet: 'Orphanet'
          }
        },
        condition: {
          ___title: 'Associated conditions',
          ___alert01: 'The condition recommended for reporting of incidental findings.',
          ___less: 'less',
          ___more: '{count} items more'
        },
        disease: {
          ___title: 'Phenotype network of selected condition',
          ___less: 'less',
          ___more: '{count} items more'
        }
      },
      regionGeneData: {
        page: {
          ___total: 'Total {total} results',
          ___display: '{display} results per page'
        }
      },
      regionVariantData: {
        ___overViewTitle: 'Overview',
        table: {
          dbVar: {
            title: {
              ___dbVarID: 'dbVar ID',
              ___Location: 'Location',
              ___Size: 'Size',
              ___Classification: 'Classification',
              ___Zygosity: 'Zygosity',
              ___Overlapinfo: 'Overlap info'
            },
            titleInfo: {
              overlapInfo: {
                ___title: 'An annotation with features overlapping the SV',
                type: {
                  ___pathogenic: 'Pathogenic SV',
                  ___other: 'Others'
                },
                formula: {
                  ___result: 'overlap (%)',
                  ___denominatorSV: 'SV to annotate length',
                  ___denominatorFeature: 'feature length',
                  ___numerator: '(length of overlap between the SV to annotate and the feature) ∗ 100'
                }
              }
            }
          },
          DECIPHER: {
            title: {
              ___DECIPHERID: 'DECIPHER ID',
              ___Location: 'Location',
              ___Size: 'Size',
              ___Classification: 'Classification',
              ___Zygosity: 'Zygosity',
              ___Phenotype: 'Phenotype',
              ___Overlapinfo: 'Overlap info'
            },
            titleInfo: {
              overlapInfo: {
                ___title: 'An annotation with features overlapping the SV',
                type: {
                  ___pathogenic: 'Pathogenic SV',
                  ___other: 'Others'
                },
                formula: {
                  ___result: 'overlap (%)',
                  ___denominatorSV: 'SV to annotate length',
                  ___denominatorFeature: 'feature length',
                  ___numerator: '(length of overlap between the SV to annotate and the feature) ∗ 100'
                }
              }
            },
            content: {
              ___more: 'more'
            },
            detailData: {
              ___hideTitle: 'Hide',
              phenotype: {
                ___title: 'Phenotype list of {id}'
              }
            }
          },
          overlapInfo: {
            title: {
              ___db: 'Database',
              ___sample: 'Case'
            }
          }
        },
        page: {
          ___total: 'Total {total} results',
          ___display: '{display} results per page'
        }
      },
      regionPublicationData: {
        table: {
          gnomAD: {
            title: {
              ___gnomADID: 'gnomAD ID',
              ___Location: 'Location',
              ___Size: 'Size',
              ___AlleleFrequency: 'Allele Frequency',
              ___Overlapinfo: 'Overlap info'
            },
            titleInfo: {
              overlapInfo: {
                ___title: 'An annotation with features overlapping the SV',
                formula: {
                  ___result: 'overlap (%)',
                  ___denominatorSV: 'SV to annotate length',
                  ___denominatorFeature: 'feature length',
                  ___numerator: '(length of overlap between the SV to annotate and the feature) ∗ 100'
                }
              }
            }
          },
          dbVar: {
            title: {
              ___dbVarID: 'dbVar ID',
              ___Location: 'Location',
              ___Size: 'Size',
              ___AlleleFrequency: 'Allele Frequency',
              ___Overlapinfo: 'Overlap info'
            },
            titleInfo: {
              overlapInfo: {
                ___title: 'An annotation with features overlapping the SV',
                formula: {
                  ___result: 'overlap (%)',
                  ___denominatorSV: 'SV to annotate length',
                  ___denominatorFeature: 'feature length',
                  ___numerator: '(length of overlap between the SV to annotate and the feature) ∗ 100'
                }
              }
            }
          },
          overlapInfo: {
            title: {
              ___db: 'Database',
              ___sample: 'Case'
            }
          }
        },
        page: {
          ___total: 'Total {total} results',
          ___display: '{display} results per page'
        }
      },
      repeatData: {
        table: {
          ___variantAlert: 'Variant phasing has not been considered yet.',
          icon: {
            monitor: {
              ___title01: 'add to monitor',
              ___title02: 'remove from monitor'
            },
            report: {
              ___title01: 'add to report',
              ___title02: 'remove from report'
            }
          },
          title: {
            ___position: 'Position<br>(HG38)',
            ___Region: 'Region',
            ___Repeat_unit: 'Repeat unit',
            ___REF: 'Reference copy number',
            ___ALT: 'ALT',
            ___Zygosity: 'Zygosity',
            ___Allele_Repeat_Copy_Number: 'Allele Repeat<br>Copy Number (CI)',
            ___Classification: 'Classification'
          }
        },
        externalLink: {
          title: {
            ___STRipy: 'STRipy',
            ___gnomAD: 'gnomAD',
            ___OMIM: 'OMIM',
            ___HPO: 'HPO'
          }
        },
        condition: {
          ___title: 'Conditions',
          ___alert01: 'The condition recommended for reporting of incidental findings.',
          ___more: '{count} items more'
        }
      },
      report: {
        ___editTitle: 'Report Tool box',
        ___templateTitle: 'Template',
        ___reportTitle: 'Report Preview & Editing',
        page: {
          title: {
            ___pre: 'previous section',
            ___next: 'next section'
          }
        }
      }
    },
    caseList: {
      single: {
        ___roleFilterTitle: 'Role',
        ___searchPlaceholder: 'Type Keywords, e.g., Case ID, name… to search',
        table: {
          title: {
            ___case_id: 'Case ID',
            ___sex: 'Sex',
            ___birth_year: 'Age',
            ___population: 'Population',
            ___created_at: 'Create Date',
            ___updated_at: 'Modified Date',
            ___user: 'Owner',
            ___seq: 'Seq',
            ___state: 'Status',
            ___note: 'Note',
            ___workgroup: 'Workgroup',
            ___stage: 'Stage',
            ___due_date: 'Due date',
            ___assignee: 'Assignee'
          },
          content: {
            seq: {
              ___WES: 'WES',
              ___WES_MT: 'WES+MT',
              ___WGS: 'WGS'
            },
            workgroup_stage: {
              ___select: 'Select a Stage'
            }
          },
          display: {
            sex: {
              ___Male: 'M',
              ___Female: 'F',
              ___Unknown: 'U'
            }
          }
        },
        modal: {
          content: {
            ___pointAlert: '<span style="color:#FA3D3D">Create a case need {price} points, you don’t have enough points. Do you want to buy more?</span>'
          }
        }
      }
    },
    dataset: {
      base: {
        customForm: {
          tag: {
            ___dataTagPlaceholder: 'Name of tags'
          }
        },
        picture: {
          ___title: 'Picture of dataset',
          ___customTitle: 'Custom picture'
        },
        sample: {
          ___title: 'Samples of the dataset',
          ___info: '{count} sample selected | {count} samples selected',
          viewTitle: {
            ___detail: 'Detail view',
            ___list: 'List view'
          },
          searchPlaceholder: {
            ___case: 'Case ID of the samples',
            ___dataset: 'Keywords of dataset'
          },
          emptyText: {
            ___case: 'No sample was selected to the dataset.'
          }
        },
        sampleTable: {
          case: {
            ___case_id: 'Case ID',
            ___sex: 'Sex',
            ___birth_year: 'Age',
            ___created_at: 'Create',
            ___updated_at: 'Modified'
          },
          dataset: {
            ___name: 'Dataset name',
            ___sample_size: 'Sample Size',
            ___user: 'Owner',
            ___detail: 'Detail'
          }
        },
        sampleList: {
          title: {
            ___case: 'My selected samples',
            ___dataset: 'Community datasets'
          }
        },
        form: {
          title: {
            ___owner: 'Owner',
            ___name: 'Dataset name',
            ___tag: 'Add tags',
            ___pipeline: 'Pipeline',
            ___description: 'Dataset description'
          },
          placeholder: {
            ___name: 'Dataset name.',
            ___tag: 'Name of tags',
            ___pipeline: 'Pipeline',
            ___description: 'Note any description of the dataset.'
          },
          customValidate: {
            ___user_id: 'Name has already been taken.',
            ___sample_size: 'Sample size is too small.'
          }
        }
      },
      card: {
        annotation: {
          default: {
            ___info01: 'The dataset with all your data',
            ___info02: 'is selected for annotation.'
          },
          community: {
            ___info01: 'The dataset with community data',
            ___info02: 'is selected for annotation.'
          }
        },
        information: {
          title: {
            ___Create: 'Create',
            ___Modified: 'Modified',
            ___Samplesize: 'Sample size',
            ___Pipeline: 'Pipeline',
            ___Externaldata: 'External data',
            ___Status: 'Status',
            ___Permission: 'Permission'
          },
          value: {
            external_data_included: {
              ___Yes: 'Yes',
              ___No: 'No'
            }
          }
        }
      },
      disabledMsg: {
        ___title01: 'One or more samples/datasets have been removed from the {dataset} ({time} Created). This dataset is no longer available to you. The table below shows the datasets that revoke the sharing.',
        ___title02: 'One or more samples/datasets have been archived from the {dataset} ({time} Created). This dataset is no longer available to you.',
        table: {
          title: {
            ___category: 'Category',
            ___title: 'Dataset name / Case ID',
            ___modified: 'Modified',
            ___owner: 'Owner'
          }
        }
      },
      msg: {
        ___created: 'Analysis creation failed.',
        ___analyzing: 'Data Analysis is processing…',
        ___failed01: 'An unpredictable problem occurred,',
        ___failed02: 'we are excluding this problem right now.',
        ___failed03: 'An unpredictable problem occurred:'
      }
    },
    datasetDetail: {
      sample: {
        ___title: 'There are {count} sample in the dataset. | There are {count} samples in the dataset.',
        ___searchPlaceholder: 'Case ID of the samples',
        viewTitle: {
          ___detail: 'Detail view',
          ___list: 'List view'
        },
        table: {
          title: {
            ___case_id: 'Case ID',
            ___sex: 'Sex',
            ___birth_year: 'Age',
            ___created_at: 'Create',
            ___updated_at: 'Modified',
            ___dataset_name: 'Dataset name',
            ___user: 'Owner'
          }
        }
      },
      share: {
        ___invitationIconTitle: 'Copy',
        customForm: {
          url: {
            icon: {
              ___title: 'Copy'
            }
          },
          public_permission: {
            ___title: 'Public permission',
            ___alert: 'This permission allows any user to access the summary page of your dataset. It would be very convenient if you intend to demonstrate your collections to the public. Please use this permission with caution if you consider your dataset contains sensitive information. If you like to demonstrate your dataset to the users you granted, please use the Access key.'
          },
          access_key: {
            ___title: 'Access Key'
          },
          invitation_permission: {
            ___selectPlaceholder: 'Select a permission'
          }
        },
        userList: {
          ___title: 'User list',
          ___info: 'This dataset has been shared with {count} user | This dataset has been shared with {count} users'
        },
        table: {
          title: {
            ___user_id: 'User ID (organization, email)',
            ___permission: 'Permission',
            ___option: 'Edit'
          }
        },
        form: {
          title: {
            ___url: 'Dataset URL',
            ___community_permission: 'Community permission',
            ___invitation_url: 'Invitation URL'
          }
        },
        modal: {
          content: {
            ___deleteShare: '<span>If you delete the user, the permission will also be removed. <br>Do you want to delete the user?</span>'
          }
        }
      },
      summary: {
        ___filterPlaceholder01: 'Filter Selection',
        ___filterPlaceholder02: 'Operator',
        ___filterSelectPlaceholder: 'Range',
        ___filterNumberPlaceholder: 'Range',
        ___conditionJoin: 'or',
        defaultOperatorOption: {
          title: {
            in: {
              ___true: 'in',
              ___false: 'not in'
            },
            like: {
              ___true: 'in',
              ___false: 'not in'
            }
          }
        },
        summaryFilter: {
          title: {
            ___VARIANT_CLASS: 'Variant class',
            ___F_MISSING: 'Variant missing rate',
            ___AC: 'AC',
            ___AN: 'AN',
            ___AF: 'AF',
            ___NS: 'NS',
            ___DP: 'DP',
            ___AC_Het: 'AC Het',
            ___AC_Hom: 'AC Hom',
            ___AC_Hemi: 'AC Hemi',
            ___Consequence: 'Consequence',
            ___SYMBOL: 'Gene',
            ___Sex: 'Sex',
            ___HPO: 'HPO'
          },
          rangeOption: {
            title: {
              VARIANT_CLASS: {
                ___SNV: 'SNV',
                ___Ins: 'Insertion',
                ___Del: 'Deletion'
              },
              Sex: {
                ___Male: 'Male',
                ___Female: 'Female',
                ___Unknown: 'Unknown'
              }
            }
          }
        },
        summaryMain: {
          title: {
            ___dataCounts: 'Data Counts',
            ___variantCounts: 'Variant counts',
            ___geneStatistics: 'Gene statistics',
            ___phenotypeStatistics: 'Phenotype statistics',
            ___consequenceStatistics: 'Consequence statistics',
            ___consequencePerSample: 'Consequence per sample',
            ___populationDatabase: 'Comparison of AF distribution'
          },
          option: {
            geneStatisticsType: {
              ___Caseaffected: 'Case affected',
              ___Variantcount: 'Variant count'
            }
          },
          info: {
            geneStatistics: {
              ___info01: 'Case affected: Proportion of affected cases per gene.',
              ___info02: 'Mutation count: Number of variants per gene.'
            },
            phenotypeStatistics: {
              ___info01: 'Phenogram plot. The number shown in the center indicates the sum of term occurrences of path from patient\'s phenotype to HP:0000118.'
            },
            consequenceStatistics: {
              ___info01: 'The proportion of variant consequences.'
            },
            consequencePerSample: {
              ___info01: 'Number of variants per sample grouped by<br>variant consequences.'
            }
          }
        },
        chartOption: {
          geneStatisticstestChart: {
            ___yAxis01: '% of Cases Affected',
            ___yAxis02: '# of Variants'
          },
          consequencePerSample: {
            ___xAxis: '# of Variants per sample',
            ___yAxis: 'Counts',
            seriesName: {
              ___Missense: 'Missense',
              ___Null: 'Null',
              ___Synonymous: 'Synonymous'
            }
          },
          populationDatabase: {
            ___xAxis: '# of Variant (M)',
            seriesName: {
              ___cohort: 'My cohort',
              ___TOPMED: 'My cohort + TOPMED',
              ___gnomAD: 'My cohort + gnomAD Genome',
              ___all: 'My cohort + TOPMED + gnomAD Genome'
            }
          }
        },
        dataTotal: {
          title: {
            ___Total: 'Total',
            ___Male: 'M',
            ___Female: 'F'
          }
        },
        variantTotal: {
          title: {
            ___Total: 'Total variants',
            ___SNV: 'SNVs',
            ___Ins: 'Insertion',
            ___Del: 'Deletion'
          }
        },
        consequenceMapDatas: {
          title: {
            ___transcript_ablation: 'Transcript ablation',
            ___splice_acceptor_variant: 'Splice acceptor variant',
            ___splice_donor_variant: 'Splice donor variant',
            ___stop_gained: 'Stop gained',
            ___frameshift_variant: 'Frameshift variant',
            ___stop_lost: 'Stop lost',
            ___start_lost: 'Start lost',
            ___transcript_amplification: 'Transcript amplification',
            ___inframe_insertion: 'Inframe insertion',
            ___inframe_deletion: 'Inframe deletion',
            ___missense_variant: 'Missense variant',
            ___protein_altering_variant: 'Protein altering variant',
            ___splice_region_variant: 'Splice region variant',
            ___incomplete_terminal_codon_variant: 'Incomplete terminal codon variant',
            ___start_retained_variant: 'Start retained variant',
            ___stop_retained_variant: 'Stop retained variant',
            ___synonymous_variant: 'Synonymous variant',
            ___coding_sequence_variant: 'Coding sequence variant',
            ___mature_miRNA_variant: 'Mature miRNA variant',
            ___5_prime_UTR_variant: '5 prime UTR variant',
            ___3_prime_UTR_variant: '3 prime UTR variant',
            ___non_coding_transcript_exon_variant: 'Non coding transcript exon variant',
            ___intron_variant: 'Intron variant',
            ___NMD_transcript_variant: 'NMD transcript variant',
            ___non_coding_transcript_variant: 'Non coding transcript variant',
            ___upstream_gene_variant: 'Upstream gene variant',
            ___downstream_gene_variant: 'Downstream gene variant',
            ___TFBS_ablation: 'TFBS ablation',
            ___TFBS_amplification: 'TFBS amplification',
            ___TF_binding_site_variant: 'TF binding site variant',
            ___regulatory_region_ablation: 'Regulatory region ablation',
            ___regulatory_region_amplification: 'Regulatory region amplification',
            ___feature_elongation: 'Feature elongation',
            ___regulatory_region_variant: 'Regulatory region variant',
            ___feature_truncation: 'Feature truncation',
            ___intergenic_variant: 'Intergenic variant'
          }
        }
      }
    },
    setting: {
      workgroupCase: {
        ___selectAll: 'all',
        ___emptyContent: 'Select a workgroup first.',
        workgroupList: {
          ___roleTitle: 'Role',
          ___roleSelectTitle: 'Select a role',
          group: {
            title: {
              ___default: 'My Workgroups (The max number of groups is 5)',
              ___shared: 'Shared Workgroups'
            }
          }
        },
        workgroupResult: {
          member: {
            ___default: 'No member in the group | {count} member in the group | {count} members in the group'
          },
          case: {
            ___default: 'No case in the group | {count} case in the group | {count} cases in the group'
          },
          stage: {
            ___default: 'No stage in the group | {count} stage in the group | {count} stages in the group'
          }
        },
        workgroupData: {
          member: {
            ___title: 'Members'
          },
          case: {
            ___title: 'Cases'
          },
          stage: {
            ___title: 'Stage'
          }
        },
        form: {
          title: {
            ___name: 'Group Name',
            ___user: 'Created By',
            ___createdAt: 'Create Date',
            ___updatedAt: 'Modified Date',
            ___permissionSetting: 'Permission Settings',
            ___userSetting: 'User Settings'
          },
          placeholder: {
            ___name: 'Type the group name'
          },
          switchData: {
            title: {
              ___memberChange: 'Allow <b>Members</b> edit cases of group',
              ___memberEdit: 'Allow <b>Members</b> change status & assignment of cases',
              ___autoShare: 'Auto-share cases to this workgroup'
            },
            info: {
              ___memberChange: 'Case editing permission is granted to the Director by default. Configure this option to decide whether to grant editing permissions to members.',
              ___autoShare: 'Once enabled, all your newly uploaded cases will be automatically shared with this workgroup.'
            },
            disabled: {
              ___autoShare: 'You already have auto-share enabled in another workgroup.'
            }
          }
        },
        modal: {
          content: {
            ___deleteWorkgroup: '<span style="color:#FF414D">If you delete the group, shared cases and members will also be removed. Do you want to delete the group: {name}?</span>',
            ___leaveWorkgroup: '<span style="color:#FF414D">If you leave the group, shared cases will also be removed. Do you want to leave the group: {name}?</span>'
          }
        }
      },
      panelGene: {
        ___selectAll: 'all',
        ___panelSearchPlaceholder: 'Gene Panel (eg: Additional findings health related)',
        ___panelDefault: 'Default',
        ___panelGeneCount: '{count} gene | {count} genes',
        ___emptyContent: 'Select a gene panel first.',
        geneTag: {
          ___placeholder: 'Gene (eg: BRCA1), phenotype (eg: Headache), condition (eg: Breast Cancer)…'
        },
        panelResult: {
          ___selected: 'selected',
          gene: {
            ___type01: 'Free-typing',
            ___type02: 'User defined',
            ___title: 'gene | genes',
            ___empty: 'No gene'
          },
          panel: {
            ___title: 'panel | panels',
            ___empty: 'No panel'
          },
          phenotype: {
            ___title: 'phenotype | phenotypes',
            ___empty: 'No phenotype'
          },
          condition: {
            ___title: 'condition | conditions',
            ___empty: 'No condition'
          },
          pathway: {
            ___title: 'pathway | pathways',
            ___empty: 'No pathway'
          }
        },
        panelData: {
          ___searchTitle: 'Gene / Disease panel set',
          gene: {
            ___title: 'Genes',
            freeTyping: {
              ___title: 'Free-typing list'
            },
            userDefined: {
              ___title: 'User defined',
              ___updateTitle: 'Update with new excel file',
              ___updateTemplate: 'template',
              ___downloadList: 'Download list'
            }
          },
          panel: {
            ___title: 'Panels',
            item: {
              ___createdAt: 'Added at <b>{time}</b> from <b>{panel}</b>',
              ___updatedAt: 'latest update: {time}'
            }
          },
          phenotype: {
            ___title: 'HPO phenotype'
          },
          condition: {
            ___title: 'Conditions'
          },
          pathway: {
            ___title: 'Pathways'
          }
        },
        form: {
          edit: {
            title: {
              ___name: 'Gene Panel',
              ___newName: 'New Gene Panel',
              ___division: 'Division',
              ___note: 'Note',
              ___updatedAt: 'Last update',
              ___createdAt: 'Create Date'
            },
            placeholder: {
              ___name: 'ex: Seizures',
              ___division: 'Please select a division',
              ___note: 'You can type anything as your note.'
            }
          },
          default: {
            title: {
              ___name: 'Default Gene Panel',
              ___division: 'Division'
            }
          }
        },
        modal: {
          content: {
            ___deletePanel: '<span style="color:#FF414D">If you delete this panel, all the setting inside will also be deleted. Do you want to delete the panel?</span>',
            ___overwriteGeneList: '<span style="color:#FA3D3D">Overwrite the previously uploaded gene list?</span>'
          }
        }
      },
      panelPhenotype: {
        ___emptyContent: 'Select a phenotype panel first.',
        phenotypeTag: {
          ___placeholder: 'Phenotype (eg: Dyspnea) or Disease (eg: Breast Cancer)'
        },
        form: {
          title: {
            ___name: 'Phenotype Set',
            ___newName: 'New Phenotype Set'
          },
          placeholder: {
            ___name: 'ex: Seizures'
          }
        },
        table: {
          panel: {
            title: {
              ___panel: 'Phenotype Set'
            }
          },
          phenotype: {
            title: {
              ___query: 'Phenotype / Disease'
            }
          }
        },
        modal: {
          content: {
            ___deletePanel: '<span style="color:#FF414D">If you delete this panel, the phenotypes inside will also be deleted. Do you want to delete the panel?</span>',
            ___deleteFromPanel: '<span style="color:#FF414D">Do you want to delete the phenotype in panel: {panel}?</span>'
          }
        }
      },
      configFilter: {
        ___emptyContent: 'Select a config first.',
        form: {
          title: {
            ___name: 'Config Name',
            ___updatedAt: 'Last update',
            ___createdAt: 'Create Date'
          },
          placeholder: {
            ___name: 'Config Name'
          }
        },
        table: {
          config: {
            title: {
              ___name: 'Config Name'
            }
          }
        },
        modal: {
          content: {
            ___deleteConfig: '<span style="color:#FF414D">Do you want to delete the filter config:<br>{config}?</span>'
          }
        }
      }
    },
    workgroupCase: {
      memberTable: {
        title: {
          ___Name: 'Name',
          ___Organization: 'Organization & Division or subunit',
          ___Email: 'E-mail',
          ___Role: 'Role',
          ___Edit: 'Edit'
        },
        modal: {
          content: {
            ___deleteAlert: '<span style="color:#FA3D3D">If you delete the member, some shared cases will also be removed. Do you want to delete the member: {member}?</span>'
          }
        }
      },
      caseTable: {
        title: {
          ___Case_ID: 'Case ID',
          ___Owner: 'Owner',
          ___Workgroup_Stage: 'Stage',
          ___Due_date: 'Due date',
          ___Assignee: 'Assignee',
          ___Edit: 'Edit'
        },
        placeholder: {
          ___Workgroup_Stage: 'Select a Stage'
        },
        modal: {
          content: {
            ___deleteAlert: '<span style="color:#FA3D3D">If you delete the case, the shared permission will also be removed. Do you want to delete the case: {case}?</span>'
          }
        }
      },
      stageTable: {
        title: {
          ___Workgroup_Stage: 'Stage',
          ___Assignee: 'Assignee',
          ___Edit: 'Edit'
        },
        modal: {
          content: {
            ___deleteAlert: '<span style="color:#FA3D3D">If you delete the stage, the auto-assign function will also be canceled. Do you want to delete the stage: {stage}?</span>'
          }
        }
      }
    },
    config: {
      filter: {
        customConfig: {
          databaseSet: {
            ___valuePlaceholder: 'ex: 0.001'
          },
          genePanel: {
            geneTag: {
              ___placeholder: 'Gene, panel, phenotype, condition.'
            }
          },
          rsID: {
            ___valuePlaceholder: 'rs123456'
          }
        },
        defaultPlaceholder: {
          ___compare: '>, …',
          ___select: 'Type',
          ___value: 'Num.'
        },
        selectOption: {
          criteria: {
            title: {
              ___union: 'Union',
              ___intersection: 'Intersection'
            },
            resultTitle: {
              ___union: 'Union of criterias',
              ___intersection: 'Intersection of criterias'
            }
          },
          annotation: {
            title: {
              ___withAnnotation: 'With annotation',
              ___withoutAnnotation: 'Without annotation'
            },
            resultTitle: {
              ___withAnnotation: 'With annotation',
              ___withoutAnnotation: 'Without annotation'
            }
          }
        },
        configOption: {
          qualityFilter: {
            ___title: 'Quality Filter',
            configGroup: {
              default01: {
                config: {
                  filter_pass: {
                    ___valueTitle: 'Filter Pass',
                    ___resultTitle: 'Pass'
                  },
                  dp: {
                    ___switchTitle: 'DP'
                  },
                  ad: {
                    ___switchTitle: 'AD'
                  },
                  ad_dp: {
                    ___switchTitle: 'AD/DP'
                  },
                  genotype: {
                    ___switchTitle: 'Genotype filter'
                  }
                }
              }
            }
          },
          populationDatabase: {
            ___title: 'Population Databases',
            configGroup: {
              default01: {
                ___title: 'All database set',
                config: {
                  database_include_empty_values: {
                    ___valueTitle: 'Include empty values'
                  }
                }
              },
              populationDatabase_1000Genomes: {
                ___title: '1000 Genomes',
                config: {
                  KG_AF: {
                    ___checkTitle: 'AF'
                  },
                  KG_AFR_AF: {
                    ___checkTitle: 'AFR AF'
                  },
                  KG_AMR_AF: {
                    ___checkTitle: 'AMR AF'
                  },
                  KG_EAS_AF: {
                    ___checkTitle: 'EAS AF'
                  },
                  KG_EUR_AF: {
                    ___checkTitle: 'EUR AF'
                  },
                  KG_SAS_AF: {
                    ___checkTitle: 'SAS AF'
                  }
                }
              },
              populationDatabase_gnomAD: {
                ___title: 'gnomAD Exomes',
                config: {
                  gnomAD_AF: {
                    ___checkTitle: 'AF'
                  },
                  gnomAD_AFR_AF: {
                    ___checkTitle: 'AFR AF'
                  },
                  gnomAD_AMR_AF: {
                    ___checkTitle: 'AMR AF'
                  },
                  gnomAD_ASJ_AF: {
                    ___checkTitle: 'ASJ AF'
                  },
                  gnomAD_EAS_AF: {
                    ___checkTitle: 'EAS AF'
                  },
                  gnomAD_FIN_AF: {
                    ___checkTitle: 'FIN AF'
                  },
                  gnomAD_NFE_AF: {
                    ___checkTitle: 'NFE AF'
                  },
                  gnomAD_OTH_AF: {
                    ___checkTitle: 'OTH AF'
                  },
                  gnomAD_SAS_AF: {
                    ___checkTitle: 'SAS AF'
                  },
                  gnomAD_MID_AF: {
                    ___checkTitle: 'MID AF'
                  }
                }
              },
              populationDatabase_gnomAD_g: {
                ___title: 'gnomAD Genomes',
                config: {
                  gnomAD_g_AF: {
                    ___checkTitle: 'AF'
                  },
                  gnomAD_g_AF_afr: {
                    ___checkTitle: 'AFR AF'
                  },
                  gnomAD_g_AF_ami: {
                    ___checkTitle: 'AMI AF'
                  },
                  gnomAD_g_AF_amr: {
                    ___checkTitle: 'AMR AF'
                  },
                  gnomAD_g_AF_asj: {
                    ___checkTitle: 'ASJ AF'
                  },
                  gnomAD_g_AF_eas: {
                    ___checkTitle: 'EAS AF'
                  },
                  gnomAD_g_AF_fin: {
                    ___checkTitle: 'FIN AF'
                  },
                  gnomAD_g_AF_mid: {
                    ___checkTitle: 'MID AF'
                  },
                  gnomAD_g_AF_nfe: {
                    ___checkTitle: 'NFE AF'
                  },
                  gnomAD_g_AF_oth: {
                    ___checkTitle: 'OTH AF'
                  },
                  gnomAD_g_AF_sas: {
                    ___checkTitle: 'SAS AF'
                  },
                  gnomAD_g_mt_AF_het: {
                    ___checkTitle: 'Heteroplasmy AF'
                  },
                  gnomAD_g_mt_pop_AF_het_afr: {
                    ___checkTitle: 'Heteroplasmy AFR AF'
                  },
                  gnomAD_g_mt_pop_AF_het_ami: {
                    ___checkTitle: 'Heteroplasmy AMI AF'
                  },
                  gnomAD_g_mt_pop_AF_het_amr: {
                    ___checkTitle: 'Heteroplasmy AMR AF'
                  },
                  gnomAD_g_mt_pop_AF_het_asj: {
                    ___checkTitle: 'Heteroplasmy ASJ AF'
                  },
                  gnomAD_g_mt_pop_AF_het_eas: {
                    ___checkTitle: 'Heteroplasmy EAS AF'
                  },
                  gnomAD_g_mt_pop_AF_het_fin: {
                    ___checkTitle: 'Heteroplasmy FIN AF'
                  },
                  gnomAD_g_mt_pop_AF_het_mid: {
                    ___checkTitle: 'Heteroplasmy MID AF'
                  },
                  gnomAD_g_mt_pop_AF_het_nfe: {
                    ___checkTitle: 'Heteroplasmy NFE AF'
                  },
                  gnomAD_g_mt_pop_AF_het_oth: {
                    ___checkTitle: 'Heteroplasmy OTH AF'
                  },
                  gnomAD_g_mt_pop_AF_het_sas: {
                    ___checkTitle: 'Heteroplasmy SAS AF'
                  },
                  gnomAD_g_mt_AF_hom: {
                    ___checkTitle: 'Homoplasmy AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_afr: {
                    ___checkTitle: 'Homoplasmy AFR AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_ami: {
                    ___checkTitle: 'Homoplasmy AMI AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_amr: {
                    ___checkTitle: 'Homoplasmy AMR AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_asj: {
                    ___checkTitle: 'Homoplasmy ASJ AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_eas: {
                    ___checkTitle: 'Homoplasmy EAS AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_fin: {
                    ___checkTitle: 'Homoplasmy FIN AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_mid: {
                    ___checkTitle: 'Homoplasmy MID AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_nfe: {
                    ___checkTitle: 'Homoplasmy NFE AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_oth: {
                    ___checkTitle: 'Homoplasmy OTH AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_sas: {
                    ___checkTitle: 'Homoplasmy SAS AF'
                  }
                }
              },
              populationDatabase_others: {
                ___title: 'Others',
                config: {
                  ExAC_AF: {
                    ___checkTitle: 'ExAC AF'
                  },
                  ESP6500_AA_AF: {
                    ___checkTitle: 'ESP6500 AA'
                  },
                  ESP6500_EA_AF: {
                    ___checkTitle: 'ESP6500 EA'
                  },
                  TW_AF: {
                    ___checkTitle: 'TW AF'
                  },
                  TOPMED_AF: {
                    ___checkTitle: 'TOPMed AF'
                  },
                  ChinaMAP_AF: {
                    ___checkTitle: 'ChinaMAP AF'
                  }
                }
              },
              default02: {
                ___title: 'Set of Criteria'
              }
            }
          },
          computationalPredictiveData: {
            ___title: 'Computational & Predictive data',
            configGroup: {
              default01: {
                config: {
                  predictive_include_empty_values: {
                    ___valueTitle: 'Include empty values'
                  }
                }
              },
              computationalPredictiveData_splicingImpact: {
                ___title: 'Splicing impact',
                config: {
                  ada_score: {
                    ___checkTitle: 'ada score'
                  },
                  rf_score: {
                    ___checkTitle: 'rf score'
                  },
                  CI_SpliceAI: {
                    ___checkTitle: 'CI SpliceAI'
                  },
                  SpliceAI_DS_AG: {
                    ___checkTitle: 'SpliceAI DS AG'
                  },
                  SpliceAI_DS_AL: {
                    ___checkTitle: 'SpliceAI DS AL'
                  },
                  SpliceAI_DS_DG: {
                    ___checkTitle: 'SpliceAI DS DG'
                  },
                  SpliceAI_DS_DL: {
                    ___checkTitle: 'SpliceAI DS DL'
                  }
                }
              },
              computationalPredictiveData_proteinFunction: {
                ___title: 'Protein function',
                config: {
                  Alphamissense_score: {
                    ___checkTitle: 'Alphamissense score'
                  },
                  Alphamissense_class: {
                    ___checkTitle: 'Alphamissense class'
                  },
                  SIFT4G_score: {
                    ___checkTitle: 'SIFT4G score'
                  },
                  SIFT4G_pred: {
                    ___checkTitle: 'SIFT4G pred'
                  },
                  Polyphen_score: {
                    ___checkTitle: 'Polyphen-2 HDIV'
                  },
                  Polyphen_pred: {
                    ___checkTitle: 'Polyphen-2 HDIV pred'
                  },
                  FATHMM_score: {
                    ___checkTitle: 'FATHMM score'
                  },
                  FATHMM_pred: {
                    ___checkTitle: 'FATHMM pred'
                  },
                  PROVEAN_score: {
                    ___checkTitle: 'PROVEAN score'
                  },
                  PROVEAN_pred: {
                    ___checkTitle: 'PROVEAN pred'
                  }
                }
              },
              computationalPredictiveData_ensemble: {
                ___title: 'Ensemble',
                config: {
                  CADD_phred: {
                    ___checkTitle: 'CADD phred'
                  },
                  CADD_raw: {
                    ___checkTitle: 'CADD raw'
                  },
                  MetaLR_score: {
                    ___checkTitle: 'MetaLR score'
                  },
                  MetaLR_pred: {
                    ___checkTitle: 'MetaLR pred'
                  },
                  MetaSVM_score: {
                    ___checkTitle: 'MetaSVM score'
                  },
                  MetaSVM_pred: {
                    ___checkTitle: 'MetaSVM pred'
                  },
                  REVEL_score: {
                    ___checkTitle: 'REVEL score'
                  },
                  REVEL_pred: {
                    ___checkTitle: 'REVEL pred'
                  },
                  BayesDel_noAF_score: {
                    ___checkTitle: 'BayesDel noAF score'
                  },
                  BayesDel_noAF_pred: {
                    ___checkTitle: 'BayesDel noAF pred'
                  }
                }
              },
              computationalPredictiveData_conservation: {
                ___title: 'Conservation',
                config: {
                  GERPpp_NR: {
                    ___checkTitle: 'GERP++ NR'
                  },
                  GERPpp_RS: {
                    ___checkTitle: 'GERP++ RS'
                  }
                }
              },
              computationalPredictiveData_gnomADConstraint: {
                ___title: 'gnomAD Constraint',
                config: {
                  oe_syn: {
                    ___checkTitle: 'Synonymous o/e'
                  },
                  oe_mis: {
                    ___checkTitle: 'Missense o/e'
                  },
                  oe_lof: {
                    ___checkTitle: 'pLoF o/e'
                  },
                  syn_z: {
                    ___checkTitle: 'Synonymous z-score'
                  },
                  mis_z: {
                    ___checkTitle: 'Missense z-score'
                  },
                  pLI: {
                    ___checkTitle: 'pLI'
                  }
                }
              },
              default02: {
                ___title: 'Set of Criteria'
              }
            }
          },
          consequences: {
            ___title: 'Consequences',
            configGroup: {
              consequences_high: {
                ___title: 'High',
                config: {
                  frameshift_elongation: {
                    ___valueTitle: 'Frameshift elongation'
                  },
                  frameshift_truncation: {
                    ___valueTitle: 'Frameshift truncation'
                  },
                  frameshift_variant: {
                    ___valueTitle: 'Frameshift variant'
                  },
                  splice_acceptor_variant: {
                    ___valueTitle: 'Splice acceptor variant'
                  },
                  splice_donor_variant: {
                    ___valueTitle: 'Splice donor variant'
                  },
                  start_lost: {
                    ___valueTitle: 'Start lost'
                  },
                  stop_gained: {
                    ___valueTitle: 'Stop gained'
                  },
                  stop_lost: {
                    ___valueTitle: 'Stop lost'
                  },
                  transcript_ablation: {
                    ___valueTitle: 'Transcript ablation'
                  },
                  transcript_amplification: {
                    ___valueTitle: 'Transcript amplification'
                  }
                }
              },
              consequences_low: {
                ___title: 'Low',
                config: {
                  incomplete_terminal_codon_variant: {
                    ___valueTitle: 'Incomplete terminal codon variant'
                  },
                  splice_region_variant: {
                    ___valueTitle: 'Splice region variant'
                  },
                  start_retained_variant: {
                    ___valueTitle: 'Start retained variant'
                  },
                  stop_retained_variant: {
                    ___valueTitle: 'Stop retained variant'
                  },
                  synonymous_variant: {
                    ___valueTitle: 'Synonymous variant'
                  }
                }
              },
              consequences_moderate: {
                ___title: 'Moderate',
                config: {
                  direct_tandem_duplication: {
                    ___valueTitle: 'Direct tandem duplication'
                  },
                  disruptive_inframe_deletion: {
                    ___valueTitle: 'Disruptive inframe deletion'
                  },
                  disruptive_inframe_insertion: {
                    ___valueTitle: 'Disruptive inframe insertion'
                  },
                  inframe_deletion: {
                    ___valueTitle: 'Inframe deletion'
                  },
                  inframe_insertion: {
                    ___valueTitle: 'Inframe insertion'
                  },
                  missense_variant: {
                    ___valueTitle: 'Missense variant'
                  },
                  protein_altering_variant: {
                    ___valueTitle: 'Protein altering variant'
                  },
                  regulatory_region_ablation: {
                    ___valueTitle: 'Regulatory region ablation'
                  }
                }
              },
              consequences_modifier: {
                ___title: 'Modifier',
                config: {
                  __3_prime_UTR_exon_variant: {
                    ___valueTitle: '3 prime UTR exon variant'
                  },
                  __3_prime_UTR_intron_variant: {
                    ___valueTitle: '3 prime UTR intron variant'
                  },
                  __3_prime_UTR_variant: {
                    ___valueTitle: '3 prime UTR variant'
                  },
                  __5_prime_UTR_exon_variant: {
                    ___valueTitle: '5 prime UTR exon variant'
                  },
                  __5_prime_UTR_intron_variant: {
                    ___valueTitle: '5 prime UTR intron variant'
                  },
                  __5_prime_UTR_variant: {
                    ___valueTitle: '5 prime UTR variant'
                  },
                  coding_sequence_variant: {
                    ___valueTitle: 'Coding sequence variant'
                  },
                  coding_transcript_intron_variant: {
                    ___valueTitle: 'Coding transcript intron variant'
                  },
                  feature_elongation: {
                    ___valueTitle: 'Feature elongation'
                  },
                  feature_truncation: {
                    ___valueTitle: 'Feature truncation'
                  },
                  intergenic_variant: {
                    ___valueTitle: 'Intergenic variant'
                  },
                  intron_variant: {
                    ___valueTitle: 'Intron variant'
                  },
                  mature_miRNA_variant: {
                    ___valueTitle: 'Mature miRNA variant'
                  },
                  NMD_transcript_variant: {
                    ___valueTitle: 'NMD transcript variant'
                  },
                  non_coding_transcript_exon_variant: {
                    ___valueTitle: 'Non coding transcript exon variant'
                  },
                  non_coding_transcript_intron_variant: {
                    ___valueTitle: 'Non coding transcript intron variant'
                  },
                  non_coding_transcript_variant: {
                    ___valueTitle: 'Non coding transcript variant'
                  },
                  regulatory_region_amplification: {
                    ___valueTitle: 'Regulatory region amplification'
                  },
                  regulatory_region_variant: {
                    ___valueTitle: 'Regulatory region variant'
                  },
                  TF_binding_site_variant: {
                    ___valueTitle: 'TF binding site variant'
                  },
                  TFBS_ablation: {
                    ___valueTitle: 'TFBS ablation'
                  },
                  TFBS_amplification: {
                    ___valueTitle: 'TFBS amplification'
                  }
                }
              },
              default01: {
                config: {
                  consequences_exact_match: {
                    ___valueTitle: 'Exact match'
                  }
                }
              }
            }
          },
          miscellaneous: {
            ___title: 'Miscellaneous',
            configGroup: {
              default01: {
                ___resultTitle: 'Gene Filter'
              },
              miscellaneous_genome_coordinate: {
                ___title: 'Genome coordinate filter',
                ___resultTitle: 'Genome Filter',
                config: {
                  genome_coordinate_filter: {
                    ___valuePlaceholder: 'X or 1:12345-12345 or 1:13456-150213…'
                  }
                }
              },
              miscellaneous_rs_id: {
                ___title: 'rs ID filter',
                ___resultTitle: 'rs ID Filter'
              },
              miscellaneous_clinVar: {
                ___title: 'ClinVar',
                config: {
                  clinvar_Pathogenic: {
                    ___valueTitle: 'Pathogenic'
                  },
                  clinvar_Likely_pathogenic: {
                    ___valueTitle: 'Likely pathogenic'
                  },
                  clinvar_Uncertain_significance: {
                    ___valueTitle: 'Uncertain significance'
                  },
                  clinvar_Conflicting_interpretations_of_pathogenicity: {
                    ___valueTitle: 'Conflicting interpretations of pathogenicity'
                  },
                  clinvar_Benign: {
                    ___valueTitle: 'Benign'
                  },
                  clinvar_Likely_benign: {
                    ___valueTitle: 'Likely benign'
                  },
                  clinvar_risk_factor: {
                    ___valueTitle: 'Risk factor'
                  },
                  clinvar_other: {
                    ___valueTitle: 'Other'
                  },
                  clinvar_drug_response: {
                    ___valueTitle: 'Drug response'
                  },
                  clinvar_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              miscellaneous_mastermind: {
                ___title: 'Mastermind',
                config: {
                  mastermind_Pathogenic: {
                    ___valueTitle: 'Pathogenic'
                  },
                  mastermind_Likely_pathogenic: {
                    ___valueTitle: 'Likely pathogenic'
                  },
                  mastermind_Conflict: {
                    ___valueTitle: 'Conflict'
                  },
                  mastermind_VUS: {
                    ___valueTitle: 'VUS'
                  },
                  mastermind_Likely_benign: {
                    ___valueTitle: 'Likely benign'
                  },
                  mastermind_Benign: {
                    ___valueTitle: 'Benign'
                  },
                  mastermind_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              miscellaneous_acmg: {
                ___title: 'ACMG Classification',
                config: {
                  acmg_Pathogenic: {
                    ___valueTitle: 'Pathogenic'
                  },
                  acmg_Likely_pathogenic: {
                    ___valueTitle: 'Likely pathogenic'
                  },
                  acmg_Uncertain_significance: {
                    ___valueTitle: 'Uncertain significance'
                  },
                  acmg_Benign: {
                    ___valueTitle: 'Benign'
                  },
                  acmg_Likely_benign: {
                    ___valueTitle: 'Likely benign'
                  },
                  acmg_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              default02: {
                config: {
                  clinvar_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              miscellaneous_omim: {
                ___title: 'OMIM',
                config: {
                  omim_annotation_filter: {
                    ___switchTitle: 'OMIM annotation filter'
                  }
                }
              },
              miscellaneous_inheritance: {
                ___title: 'Inheritance',
                config: {
                  inheritance_AR: {
                    ___valueTitle: 'AR'
                  },
                  inheritance_AD: {
                    ___valueTitle: 'AD'
                  },
                  inheritance_XL: {
                    ___valueTitle: 'XL'
                  },
                  inheritance_XLD: {
                    ___valueTitle: 'XLD'
                  },
                  inheritance_XLR: {
                    ___valueTitle: 'XLR'
                  },
                  inheritance_YL: {
                    ___valueTitle: 'YL'
                  },
                  inheritance_DD: {
                    ___valueTitle: 'DD'
                  },
                  inheritance_DR: {
                    ___valueTitle: 'DR'
                  },
                  inheritance_IC: {
                    ___valueTitle: 'IC'
                  },
                  inheritance_Mi: {
                    ___valueTitle: 'Mi'
                  },
                  inheritance_Mu: {
                    ___valueTitle: 'Mu'
                  },
                  inheritance_PD: {
                    ___valueTitle: 'PD'
                  },
                  inheritance_PR: {
                    ___valueTitle: 'PR'
                  },
                  inheritance_SMo: {
                    ___valueTitle: 'SMo'
                  },
                  inheritance_SMu: {
                    ___valueTitle: 'SMu'
                  }
                }
              },
              miscellaneous_family_analysis: {
                ___title: 'Family analysis',
                config: {
                  family_analysis_AD_De_Novo: {
                    ___valueTitle: 'AD De Novo'
                  },
                  family_analysis_AD: {
                    ___valueTitle: 'AD'
                  },
                  family_analysis_AR_De_Novo: {
                    ___valueTitle: 'AR De Novo'
                  },
                  family_analysis_AR: {
                    ___valueTitle: 'AR'
                  },
                  family_analysis_AR_Compound_Heterozygosity: {
                    ___valueTitle: 'AR Compound Heterozygosity'
                  },
                  family_analysis_XL_De_Novo: {
                    ___valueTitle: 'XL De Novo'
                  },
                  family_analysis_XL: {
                    ___valueTitle: 'XL'
                  },
                  family_analysis_YL_De_Novo: {
                    ___valueTitle: 'YL De Novo'
                  },
                  family_analysis_YL: {
                    ___valueTitle: 'YL'
                  }
                }
              }
            }
          }
        }
      }
    },
    filter: {
      config: {
        ___title: 'Filter Tool box',
        ___selectPlaceholder: 'Select a filter config.'
      },
      data: {
        tab: {
          title: {
            ___transcript: 'Transcript',
            ___variantDatabase: 'Variant Database',
            ___populationDatabase: 'Population Database',
            ___predictionScore: 'Prediction Score',
            ___samples: 'Samples',
            ___acmg: 'ACMG',
            ___conditions: 'Conditions'
          }
        },
        table: {
          transcript: {
            title: {
              ___symbol: 'Symbol',
              ___gene: 'Gene',
              ___feature: 'Transcript',
              ___biotype: 'Biotype',
              ___rank: 'Rank',
              ___HGVSc: 'HGVSc',
              ___HGVSp: 'HGVSp',
              ___cDNAPosition: 'cDNA position',
              ___CDSPosition: 'CDS position',
              ___proteinPosition: 'Protein position'
            }
          },
          variantDB: {
            clinVar: {
              ___title: 'ClinVar',
              title: {
                ___clinVarAccession: 'ClinVar Accession',
                ___clinVarDisease_Name: 'ClinVar Disease Name',
                ___clinVarCLNREVSTAT: 'ClinVar Review Status',
                ___cLINSIG: 'ClinVar Interpretation',
                ___cLINCONF: 'ClinVar Conflict'
              }
            },
            clinVarGeneStatistic: {
              ___title: 'ClinVar Gene Statistic'
            },
            mastermind: {
              ___title: 'Mastermind'
            },
            mitomap: {
              ___title: 'MITOMAP',
              title: {
                ___mitomapAF: 'AF',
                ___mitomapAachange: 'Amino acid changes',
                ___mitomapHomoplasmy: 'Homoplasmy',
                ___mitomapHeteroplasmy: 'Heteroplasmy',
                ___mitomapPubmedIDs: 'PubmedIDs',
                ___mitomapDisease: 'Disease',
                ___mitomapDiseaseStatus: 'Disease Status',
                ___mitomapHGFL: 'HGFL'
              }
            }
          },
          populationDB: {
          },
          prediction: {
          },
          samples: {
            title: {
              ___case_id: 'CASE ID',
              ___genotype: 'Genotype',
              ___DP: 'DP',
              ___RD: 'RD',
              ___AD: 'AD',
              ___GT_AF: 'Allele Fractions',
              ___QUAL: 'QUAL',
              ___GQ: 'Genotype Quality',
              ___FILTER: 'FILTER',
              ___x10_cov: 'Gene Coverage (10X)',
              ___x20_cov: 'Gene Coverage (20X)',
              ___x2000_cov: 'Gene Coverage (2000X)',
              ___x3000_cov: 'Gene Coverage (3000X)'
            }
          },
          condition: {
            orphanet: {
              ___title: 'Orphanet',
              linkTitle: {
                ___orphanet: 'Orphanet'
              }
            },
            omim: {
              ___title: 'OMIM',
              linkTitle: {
                ___omim: 'OMIM'
              }
            }
          }
        }
      }
    },
    report: {
      config: {
        group: {
          chapter: {
            ___title: 'Edit Section',
            display: {
              ___variantEmpty: 'No variants have been added yet.'
            }
          },
          variant: {
            ___title: 'Variants in Monitor',
            configResult: {
              ___result: '{count} variant with the tag. | {count} variants with the tag.'
            },
            result: {
              ___result: '{count} variant selected in monitor. | {count} variants selected in monitor.'
            }
          },
          cnv: {
            ___title: 'CNV management',
            result: {
              ___result: '{count} CNV in the section. | {count} CNVs in the section.'
            }
          }
        },
        subChpater: {
          default: {
            title: {
              ___displaySummary: '結果摘要',
              ___displayDetails: '詳細資訊'
            }
          },
          portrait: {
            title: {
              ___displayDetails: '結果表格',
              ___displaySummary: '文字說明'
            }
          }
        },
        modal: {
          content: {
            ___removeChapter: '<span style="color:#FA3D3D">If you delete this section, all the content inside will also be deleted. Do you want to delete the section?</span>',
            ___removeFromChapter: '<span style="color:#FA3D3D">If you delete this variant, all the content inside will also be deleted. Do you want to delete the variant?</span>',
            ___removeCNVFromChapter: '<span style="color:#FA3D3D">If you delete this variant, all the content inside will also be deleted. Do you want to delete the variant?</span>'
          }
        }
      }
    },
    chat: {
      display: {
        ___stopMsg: 'The content has been stopped.'
      }
    },
    user: {
      licenseManager: {
        ___empty: 'Please contact sales to activate your access.',
        title: {
          ___License_ID: 'License ID',
          ___Request_Code: 'Step1: Generate Activation Request Code',
          ___Activation_Code: 'Step2: Upload Activation Code',
          ___Licensed_Information: 'Licensed Information'
        },
        file: {
          title: {
            ___Request_Code: 'request_code.txt',
            ___Activation_Code: 'activation_request_code.txt'
          }
        },
        table: {
          title: {
            ___Modules: 'Modules',
            ___Status: 'Status',
            ___Started_at: 'Started at',
            ___Expired_at: 'Expired at',
            ___Licensed_Usage: 'Licensed Usage <h5>(left/total)</h5>'
          }
        },
        modal: {
          content: {
            ___removeCreateLicenseID: '<span style="color:#FA3D3D">If you delete the license, you and the users sharing this license will not be able to access this licensed function. Do you want to delete the license?</span>',
            ___removeImportLicenseID: '<span style="color:#FA3D3D">If you delete the license, you will not be able to access this licensed function. Do you want to delete the license?</span>'
          },
          confirm: {
            ___placeholder: 'Type “{confirm}” to confirm'
          }
        }
      }
    },
    tool: {
      gcsResumable: {
        gcsTable: {
          title: {
            ___caseID: 'Case ID',
            ___status: 'Status'
          }
        },
        groupState: {
          ___pending: 'Pending',
          ___failed: 'Failed'
        }
      },
      geneTag: {
        ___empty: 'No result has been found.',
        ___filterTitle: 'Search filter',
        info: {
          ___gene: 'genes',
          ___panel: 'gene panels',
          ___hpo: 'phenotypes',
          ___condition: 'conditions',
          ___pathway: 'pathways',
          ___and: 'and'
        },
        title: {
          ___all: 'All',
          ___gene: 'Genes',
          ___panel: 'Panels',
          ___hpo: 'Phenotypes',
          ___condition: 'Conditions',
          ___pathway: 'Pathways'
        }
      },
      phenotypeTag: {
        info: {
          ___hpo: 'phenotypes',
          ___disease_term: 'diseases',
          ___show: 'Showing',
          ___and: 'and'
        },
        title: {
          ___hpo: 'Phenotypes',
          ___disease_term: 'Diseases'
        },
        ___empty: 'No result has been found.'
      },
      igv: {
        ___loading: 'Loading...'
      },
      toast: {
        title: {
          ___error: 'Error !',
          ___warning: 'Warning !',
          ___notice: 'Notice !',
          ___success: 'Success !'
        }
      }
    }
  },
  // dialog
  DIALOG: {
    addLicenseID: {
      ___title: 'License ID Import',
      ___or: 'OR',
      form: {
        title: {
          ___create: 'Create a new ID',
          ___import: 'Import present license ID'
        },
        placeholder: {
          ___import: 'Please enter a present license ID'
        }
      }
    },
    addToPanel: {
      ___or: 'OR',
      form: {
        title: {
          ___phenotype: 'Phenotype',
          ___panel: 'Select a Panel',
          ___newPanel: 'Add to new panel'
        },
        placeholder: {
          ___panel: 'Please Select a Panel you need',
          ___newPanel: 'Please create a new panel name'
        },
        alert: {
          newPanel: {
            ___required: 'New panel name should not be empty.'
          }
        }
      }
    },
    addVariantToChapter: {
      variant: {
        ___title: 'Add a variant to section'
      },
      chapter: {
        ___title: 'Select at least one section'
      }
    },
    caseConfirm: {
      ___datasetTitle: '{type} Dataset',
      ___pipelineTitle: 'Pipeline',
      ___snvVcfTitle: 'SNV VCF File',
      ___svVcfTitle: 'SV VCF File',
      ___strVcfTitle: 'ExpansionHunter (STR) VCF',
      ___fastqTitle: 'Set{set}-Fastq-{read}',
      form: {
        case: {
          title: {
            ___caseID: 'Case ID',
            ___affected: 'Sample type',
            ___subjectName: 'Name',
            ___sex: 'Sex',
            ___birthYear: 'Birth Year',
            ___population: 'Population',
            ___note: 'Note'
          },
          format: {
            affected: {
              ___true: 'Affected',
              ___false: 'Unaffected'
            },
            sex: {
              ___male: 'Male',
              ___female: 'Female',
              ___unknown: 'Unknown'
            },
            birthYear: {
              ___empty: 'Unknown'
            }
          }
        },
        analysis: {
          title: {
            ___name: 'Analysis Name',
            ___note: 'Analysis note',
            ___reportPhenovardb: 'Report to PhenoVarDB',
            ___intractableDisease: 'D006-4 遺伝学的検査',
            ___intractableDiseaseTag: '指定難病分析',
            ___phenotype: 'Phenotype',
            ___genePanel: 'Gene Panel',
            ___aft: 'Allele frequency threshold for inheritance modes',
            ___st: 'Score threshold for phenotype gene selection'
          },
          aft: {
            title: {
              ___ad_cutoff: 'AD',
              ___ar_cutoff: 'AR',
              ___exclude_low_quality_variants: 'Exclude LQ variants',
              ___comp_het_cutoff: 'Compound heterozygosity',
              ___enable_clinvar_benign_filter: 'Lower priority for known benign variants'
            },
            display: {
              exclude_low_quality_variants: {
                ___true: 'ON',
                ___false: 'OFF'
              },
              enable_clinvar_benign_filter: {
                ___true: 'ON',
                ___false: 'OFF'
              }
            }
          },
          st: {
            title: {
              phenotype_score_cutoff: 'Phenotype score',
              variant_score_cutoff: 'Variant score'
            }
          },
          format: {
            reportPhenovardb: {
              ___true: 'On',
              ___false: 'Off'
            },
            intractableDiseaseTag: {
              ___true: 'Off',
              ___false: 'On'
            }
          }
        }
      },
      modal: {
        content: {
          ___unknownSexAlert: '<span style="color:#FA3D3D">Unknown sex may affect subsequent analysis results. Would you like to continue?</span>'
        }
      }
    },
    caseDetailGenePedigree: {
      ___title: 'Pedigree'
    },
    caseDetailGeneACMG: {
      ___title: 'ACMG',
      ___tabTitle: 'Rules',
      table: {
        title: {
          ___benignCriteria: 'Benign Criteria',
          ___pathogenicCriteria: 'Pathogenic Criteria',
          ___strengthofEvidence: 'Strength of Evidence',
          ___strong: 'Strong',
          ___supporting: 'Supporting',
          ___moderate: 'Moderate',
          ___veryStrong: 'Very Strong',
          ___populationData: 'Population Data',
          ___allelicEvidenceCosegrgationData: 'Allelic Evidence &<br>Cosegregation Data',
          ___computationPredictiveData: 'Computation &<br>Predictive Data',
          ___functionalData: 'Functional Data',
          ___other: 'Other',
          ___automatedCriteria: 'Automated Criteria',
          ___explanation: 'Explanation'
        }
      }
    },
    caseDetailGeneVariantDatabase: {
      ___title: 'Variant Databases',
      tab: {
        title: {
          ___clinvar: 'Clinvar',
          ___mastermind: 'Mastermind',
          ___MITOMAP: 'MITOMAP'
        }
      }
    },
    caseDetailGeneQuality: {
      ___title: 'Quality Control',
      pass: {
        readDepth: {
          ___pass: 'Read depth ≥ 10, pass.',
          ___noPass: 'Read depth < 10, no pass.'
        },
        genotypeQuality: {
          ___pass: 'Quality ≥ 20, pass.',
          ___noPass: 'Quality < 20, no pass.'
        },
        alleleFractions: {
          ___pass: 'Fractions pass.',
          ___noPass: 'Fractions no pass.'
        }
      },
      table: {
        family: {
          title: {
            ___case_id: 'Case ID',
            ___relation: 'Relation',
            ___ra: 'Ref/Alt'
          }
        },
        default: {
          title: {
            ___genotype: 'Genotype',
            ___readDepth: 'Read depth',
            ___alleleFractions: 'Allele Fractions',
            ___genotypeQuality: 'Genotype Quality',
            ___geneCoverage: 'Gene Coverage(CDS)'
          },
          option: {
            geneCoverage: {
              ___x10Cov: '10X',
              ___x20Cov: '20X'
            }
          }
        },
        mt: {
          title: {
            ___readDepth: 'Read depth',
            ___alleleFractions: 'Allele Fractions',
            ___geneCoverage: 'Gene Coverage(CDS)'
          },
          option: {
            geneCoverage: {
              ___x2000Cov: '2000X',
              ___x3000Cov: '3000X'
            }
          }
        }
      }
    },
    caseDetailGenePreview: {
      ___psTitle: 'Prediction Scores',
      ___pdTitle: 'Population Databases',
      tab: {
        title: {
          ___display: 'Display DB',
          ___select: 'DB select'
        },
        info: {
          select: {
            ___ps: '<b style=color:#003679>You can select {limit} databases <span>({count} of {limit} databases selected)</span> to show on the table.</b>'
          }
        }
      }
    },
    caseDetailRegionGene: {
      ___title: 'Genes List'
    },
    caseDetailRegionQuality: {
      ___title: 'Quality and Info',
      ___infoTitle: 'Info',
      pass: {
        genotypeQuality: {
          ___pass: 'Quality ≥ 15, pass.',
          ___noPass: 'Quality < 15, no pass.'
        }
      },
      table: {
        default: {
          title: {
            ___genotype: 'Genotype',
            ___filter: 'Filter',
            ___genotypeQuality: 'Genotype Quality',
            ___phredScaled: 'The phred-scaled genotype likelihoods',
            ___PairedRead: 'Paired Read',
            ___SplitRead: 'Split Read'
          }
        },
        info: {
          title: {
            ___IMPRECISE: 'IMPRECISE',
            ___Confidence: 'Confidence interval around position',
            ___SV_Length: 'SV Insert Length',
            ___BF: 'BF',
            ___RATIO: 'RATIO',
            ___SV_Sequence: 'SV Insert Sequence'
          }
        }
      }
    },
    caseDetailRegionVariant: {
      ___title: 'Variant Databases',
      tab: {
        title: {
          ___dbVar: 'dbVar',
          ___DECIPHER: 'DECIPHER'
        }
      }
    },
    caseDetailRegionPublication: {
      ___title: 'Population Databases',
      tab: {
        title: {
          ___gnomAD_SV: 'gnomAD SV',
          ___dbVar: 'dbVar'
        }
      }
    },
    caseDetailRegionCaller: {
      ___title: 'Detail of {count} Support Caller | Detail of {count} Support Callers',
      table: {
        title: {
          ___caller: 'Caller',
          ___description: 'Description'
        }
      }
    },
    caseEdit: {
      modal: {
        content: {
          ___changeOwner: '<span style="color:#FA3D3D">Once you change the owner, the case will be transferred from {old_owner} to {new_owner}. Do you want to transfer it?</span>'
        }
      }
    },
    caseFile: {
      ___title: 'Data Information',
      fastq: {
        ___title: 'Fastq Files',
        ___file: '<b>Set{set}-{read}: </b>{file}',
        infoTitle: {
          ___omics: 'Omics',
          ___pipeline: 'Pipeline',
          ___libraryType: 'Library Type',
          ___totalBases: 'Total Bases'
        }
      },
      vcf: {
        ___snvTitle: 'SNV VCF file',
        ___svTitle: 'SV VCF file',
        ___strTitle: 'ExpansionHunter (STR) VCF'
      },
      limit: {
        ___limitInfo: 'Due to bandwidth limits, <b>users are allowed to download large files (e.g., BAM files) once by default</b>. If you need additional quota, please contact our sales representative.',
        ___limitAlert: 'can only be download ONCE',
        ___times: 'Downloaded times: {times}'
      }
    },
    caseAnalysisVersion: {
      ___title: 'Analysis Version',
      mainData: {
        title: {
          ___pipeline: 'Pipeline Version <span>(Step1 of analysis)</span>',
          ___analysis: 'Annotation Version <span>(Step2 of analysis)</span>'
        }
      },
      tableData: {
        pipeline: {
          category: {
            ___Hardware_Accelerated_Pipeline: 'Hardware-Accelerated Pipeline',
            ___GPU_Accelerated_Pipeline_Wrapper: 'GPU-Accelerated Pipeline Wrapper',
            ___Read_Aligner: 'Read Aligner (GPU-Accelerated)',
            ___Variant_Caller: 'Variant Caller (GPU-Accelerated)',
            ___Structural_Variant_Caller: 'Structural Variant Caller',
            ___CNV_Caller_Exome_Based: 'CNV Caller (Exome-Based)',
            ___CNV_Caller_Control_Dataset: 'CNV Caller Control Dataset',
            ___Repeat_Expansion_Caller: 'Repeat Expansion Caller',
            ___HLA_Genotyper: 'HLA Genotyper'
          },
          name: {
            ___DRAGEN: 'DRAGEN',
            ___Parabrick_pbrun: 'Parabrick pbrun',
            ___Parabrick_BWA_mem: 'Parabrick BWA mem',
            ___Parabrick_deepvariant: 'Parabrick deepvariant',
            ___Manta: 'Manta',
            ___ExomeDepth: 'ExomeDepth',
            ___ExomeDepth_Baseline: 'ExomeDepth Baseline',
            ___ExpansionHunter: 'ExpansionHunter',
            ___HISAT_genotype: 'HISAT-genotype'
          }
        },
        analysis: {
          category: {
            ___Variant_Annotation_Tools: 'Variant Annotation Tools',
            ___Variant_Annotation_Tools_Database: 'Variant Annotation Tools Database',
            ___Canonical_Transcript_Reference: 'Canonical Transcript Reference',
            ___Protein_Function_Database: 'Protein Function Database',
            ___Structural_Variant_Database: 'Structural Variant Database',
            ___Population_Frequency_Database: 'Population Frequency Database',
            ___Clinical_Variant_Database: 'Clinical Variant Database',
            ___In_Silico_Prediction_Database: 'In Silico Prediction Database',
            ___Variant_Identifier_Database: 'Variant Identifier Database',
            ___Disease_Gene_Database: 'Disease Gene Database',
            ___Mitochondrial_Variant_Database: 'Mitochondrial Variant Database',
            ___Phenotype_Ontology_Database: 'Phenotype Ontology Database'
          },
          name: {
            ___Jannovar: 'Jannovar',
            ___VEP: 'VEP',
            ___AnnotSV: 'AnnotSV ',
            ___Jannovar_DB_Version: 'Jannovar DB Version',
            ___MANE: 'MANE',
            ___UniProt: 'UniProt',
            ___dbVar: 'dbVar (SV)',
            ___Decipher: 'Decipher (SV)',
            ___GnomAD: 'GnomAD (SV)',
            ___ClinVar: 'ClinVar',
            ___dbNSFP: 'dbNSFP',
            ___dbscSNV: 'dbscSNV',
            ___SpliceAI: 'CI-Splice AI',
            ___AlphaMissense: 'AlphaMissense',
            ___dbSNP: 'dbSNP',
            ___ESP6500: 'ESP6500',
            ___ExAC: 'ExAC',
            ___GenomeAsia_100K: 'GenomeAsia 100K',
            ___gnomAD_Exomes: 'gnomAD Exomes',
            ___gnomAD_Genomes: 'gnomAD Genomes',
            ___1000_Genomes: '1000 Genomes',
            ___TaiwanBioBank: 'TaiwanBioBank',
            ___tommo_60kjpn: 'tommo_60kjpn',
            ___TOPMed: 'TOPMed',
            ___OMIM: 'OMIM',
            ___Orphanet: 'Orphanet',
            ___MITOMAP: 'MITOMAP',
            ___HPO: 'HPO'
          }
        }
      }
    },
    caseDetailSVFilter: {
      ___title: 'SV Filter',
      gene: {
        ___title: 'Gene Symbol',
        ___placeholder: 'ROR1, TP53, or BRCA1...',
        selected: {
          ___title: 'Selected (The upper limit is 10 genes.)'
        }
      },
      condition: {
        ___title: 'Conditions',
        ___placeholder: 'Disease (eg: Breast Cancer)',
        selected: {
          ___title: 'Selected (The upper limit is 10 conditions.)'
        }
      },
      variantDatabase: {
        ___title: 'Variant databases',
        ClinVar: {
          ___title: 'ClinVar'
        },
        DECIPHER: {
          ___title: 'DECIPHER'
        }
      },
      afFilter: {
        ___title: 'AF filter',
        ___placeholder: '0~0.2, eg:0.01'
      },
      DosageSensitivity: {
        ___title: 'Dosage Sensitivity'
      },
      caller: {
        ___title: 'SV Callers',
        genotype: {
          ___title: 'Genotype'
        },
        svType: {
          ___title: 'SV Type'
        },
        genotypeQuality: {
          ___title: 'GQ',
          ___info: 'Genotype Quality (GQ) ≥ 30 recommended.'
        },
        numberOfCallers: {
          ___title: 'Number of Callers'
        }
      }
    },
    datasetArchiveConfirm: {
      info01: 'The following community dataset will be archived from your data pool, and any dataset associated with this community dataset will no longer be available to you.',
      info02: '<b>{count}</b> dataset will be not available. | <b>{count}</b> datasets will be not available.',
      table: {
        title: {
          ___name: 'Dataset name',
          ___owner: 'Owner',
          ___description: 'Dataset description'
        }
      }
    },
    datasetDeleteConfirm: {
      info01: 'This dataset has been shared with the community or other users. Would you like to revoke the sharing and delete the dataset?',
      info02: '<b>{count}</b> dataset will be not available. | <b>{count}</b> datasets will be not available.',
      table: {
        data: {
          ___user: 'PhenoVarDB Community'
        },
        title: {
          ___accectedUserID: 'Affected User ID (organization, email)',
          ___permission: 'Permission'
        }
      }
    },
    datasetDetail: {
      form: {
        title: {
          ___name: 'Dataset name',
          ___sampleSize: 'Sample size',
          ___user: 'Owner'
        }
      },
      table: {
        title: {
          ___caseID: 'Case ID',
          ___sex: 'Sex',
          ___birthYear: 'Age',
          ___createdAt: 'Create',
          ___updatedAt: 'Modified'
        }
      }
    },
    datasetEdit: {
      customForm: {
        shareAlert: {
          ___content: '<b>Not available</b>'
        },
        sharing: {
          ___content: 'Community'
        },
        url: {
          ___copyIconTitle: 'Copy'
        },
        user: {
          ___content: '{count} user | {count} users'
        }
      },
      form: {
        title: {
          ___shareAlert: 'Sharing',
          ___sharing: 'Sharing',
          ___url: 'Dataset URL',
          ___user: 'Users',
          ___key: 'Access Key'
        }
      }
    },
    datasetInvitationConfirm: {
      info01: '{user} has granted you access to the dataset shown above. Would you like to accept the invitation?'
    },
    datasetSelectCase: {
      ___topTitle01: 'Total samples are <b>{count}</b>.',
      ___topTitle02: 'You can import all of them with the button.',
      ___searchPlaceholder: 'Keywords of the samples',
      table: {
        title: {
          ___caseID: 'Case ID',
          ___sex: 'Sex',
          ___birthYear: 'Age',
          ___createdAt: 'Create',
          ___updatedAt: 'Modified',
          ___phenotypeDatas: 'Phenotype',
          ___genePanels: 'Gene / Disease panel'
        }
      }
    },
    datasetShareEdit: {
      form: {
        title: {
          ___user: 'User',
          ___permission: 'Permission',
          ___email: 'E-mail'
        }
      }
    },
    editChapter: {
      form: {
        title: {
          ___title: 'Name of the section',
          ___newTitle: 'Name of the new section',
          ___description: 'Description of the section'
        },
        placeholder: {
          ___title: 'New section',
          ___description: 'Please type the introduction or description of the section.'
        }
      }
    },
    editCNVToChapter: {
      ___editTitle: 'Edit the new CNV',
      ___newTitle: 'Create a new CNV',
      ___geneTitle: 'Enter relevant gene symbols',
      ___chapterTitle: 'Select at least one section',
      cnvForm: {
        placeholder: {
          ___chrom: 'Chr',
          ___posStart: 'Start Position',
          ___posEnd: 'End Position'
        }
      },
      geneTag: {
        ___placeholder: 'Gene name'
      },
      modal: {
        content: {
          ___deleteCNV: '<span style="color:#FA3D3D">If you delete this variant, all the content inside will also be deleted. Do you want to delete the variant?</span>'
        }
      }
    },
    editPanel: {
      form: {
        title: {
          ___panel: 'New panel name'
        },
        placeholder: {
          ___panel: 'Please create a new panel name'
        }
      }
    },
    editReportCNV: {
      ___typeTitle: 'Change mutation classification of the CNV',
      ___gtTitle: 'Change GT of CNV',
      ___intronTitle: 'Change intron / exon of the CNV',
      ___lengthTitle: 'Change length of the CNV',
      cnvForm: {
        title: {
          ___type: 'Select a type of the <b>CNV</b>',
          ___parentalOrigin: 'Select a Parental Origin of <b>CNV</b>'
        },
        placeholder: {
          ___gt: 'GT of CNV',
          ___intron: 'intron / exon of the CNV',
          ___length: 'length of the CNV'
        }
      }
    },
    editReportVariant: {
      ___acmgTitle: 'Change the ACMG classification of the variant',
      ___siftPolyphen2Title: 'Change the SIFT & Polyphen2 classification of the variant',
      variantForm: {
        title: {
          ___acmg: 'Select a classification',
          ___sift: 'Select a classification of <b>SIFT</b>',
          ___polyphen2: 'Select a classification of <b>Polyphen2</b>',
          ___parentalOrigin: 'Select a Parental Origin'
        }
      }
    },
    fileCloud: {
      ___title: 'List of google bucket file',
      ___subtitle: 'Please select SINGLE file to upload.'
    },
    editWorkgroupMember: {
      form: {
        title: {
          ___member: 'Member',
          ___newMember: 'New member',
          ___role: 'Role'
        },
        placeholder: {
          ___member: 'ex: InheriNext@compassbioinfo.com',
          ___role: 'Please Select a Role'
        }
      }
    },
    editWorkgroupCase: {
      ___title: 'Case list',
      ___info: '{count} case selected | {count} case selected | {count} cases selected',
      ___searchPlaceholder: 'Type Keywords of case ID to search',
      table: {
        title: {
          ___Case_ID: 'Case ID',
          ___Sex: 'Sex',
          ___Age: 'Age',
          ___Created_date: 'Created date',
          ___Modified_date: 'Modified date',
          ___Stage: 'Stage',
          ___Workgroup: 'Workgroup'
        },
        alert: {
          ___added: 'The case has been added to the workgroup.'
        },
        pageDisplay: {
          ___item: '{count} case | {count} cases',
          ___jump: 'Go to'
        }
      },
      modal: {
        content: {
          ___checkAutoShare: '<span>Do you want to automatically share your future cases with this workgroup?</span>'
        }
      }
    },
    editWorkgroupStage: {
      form: {
        title: {
          ___stage: 'stage',
          ___newStage: 'New stage',
          ___assignee: 'Assignee'
        },
        placeholder: {
          ___stage: 'Please enter a maximum of 20 characters for the stage.',
          ___assignee: 'Please Select a member'
        }
      }
    },
    genePanelConfirm: {
      ___info01: 'The following list is the modified detail, please confirm again before update.',
      block: {
        title: {
          ___add: 'Add',
          ___remove: 'Remove'
        },
        content: {
          ___geneFreeTyping: 'Gene-Free typing',
          ___geneUserDefined: 'Gene-User defined',
          ___panel: 'Panel',
          ___hpoPhenotypes: 'HPO phenotypes',
          ___conditions: 'Conditions',
          ___pathways: 'Pathways'
        }
      }
    },
    genePanelInfo: {
      ___info01: 'Welcome to <b>Gene panel tool</b>,',
      ___info02: 'a free and public search tool.',
      ___info03: '<span>Please leave your information first, thank you.</span>',
      form: {
        title: {
          ___name: 'Your Name',
          ___organization: 'Organization',
          ___email: 'Your Email'
        },
        errorTitle: {
          ___name: 'Name',
          ___organization: 'Organization',
          ___email: 'E-mail'
        },
        placeholder: {
          ___name: 'Ex: Eric Tsai or 李大平',
          ___organization: 'Ex: Taiwan Biobank or 康百事生物資訊股份有限公司',
          ___email: 'Your E-mail eg: info@compassbioinfo.com'
        }
      }
    },
    genePanelQuickSelection: {
      ___title: 'Quick selection by Division',
      block: {
        subtitle: {
          ___panel01: 'Default',
          ___panel02: 'Gene counts'
        },
        content: {
          ___division: 'Panel counts'
        }
      }
    },
    projectEdit: {
      form: {
        title: {
          ___import: 'Import Parameters'
        },
        placeholder: {
          ___import: 'Select a analysis'
        }
      },
      modal: {
        content: {
          ___unknownSexAlert: '<span style="color:#FA3D3D">Unknown sex may affect subsequent analysis results. Would you like to continue?</span>'
        }
      }
    },
    selectDataset: {
      ___description: 'Please choose the format before creating a case.<br>InheriNext also support creating VCF cases by batch-upload.',
      select: {
        title: {
          ___vcf: 'VCF',
          ___fastq: 'FASTQ'
        },
        description: {
          ___vcf: '<b>{price}</b> points/case',
          ___fastq: '<b>{price}</b> points/case'
        },
        option: {
          ___batch: 'Batch-upload'
        }
      }
    },
    userAvatar: {
      ___userTitle: 'Select a avatar from default set or upload from drive',
      ___customTitle: 'Custom avatar'
    },
    userConfirm: {
      ___mainTitle: 'Success !',
      ___title01: 'We\'ve sent a verification code to your E-mail address.',
      ___title02: 'Please enter verification code to login.',
      form: {
        title: {
          ___code: 'Verification'
        },
        placeholder: {
          ___code: '6 digits code'
        }
      }
    },
    intractableDiseaseSelect: {
      ___title: 'D006-4 遺伝学的検査疾患名'
    },
    chatbot: {
      ___busyTitle: 'All instances are busy, please wait 10 minutes and retry again.',
      ___inputPlaceholder: 'tell me about KABUKI SYNDROME',
      ___deleteAlert: 'This converstion will be deleted!<br>Would you like to continue?',
      button: {
        default: {
          clinVar: {
            ___title: 'Information of variant annotation in ClinVar, e.g. the clinical significance of chr3:37042330C>T variant',
            ___content: 'What is the clinical significance of chr3:37042330C>T variant?'
          },
          caseReports: {
            ___title: 'Source links for case reports on the variant, e.g. the case reports of chr1:69589G>A variant',
            ___content: 'What are the case reports of chr1:69589G>A variant?'
          },
          prevalence: {
            ___title: 'Provide the prevalence, etiology and inheritance of the disease, e.g. the prevalence of Kabuki Syndrome',
            ___content: 'What is the prevalence of Kabuki Syndrome?'
          },
          disease: {
            ___title: 'References and source links for the disease, e.g. the references related to Alzheimer disease',
            ___content: 'What are the references related to Alzheimer disease?'
          }
        }
      }
    }

  },
  // constant
  CONSTANT: {
    data: {
      countryCode: {
        name: {
          ___AF: 'Afghanistan',
          ___AX: 'Aland Islands',
          ___AL: 'Albania',
          ___DZ: 'Algeria',
          ___AS: 'American Samoa',
          ___AD: 'Andorra',
          ___AO: 'Angola',
          ___AI: 'Anguilla',
          ___AQ: 'Antarctica',
          ___AG: 'Antigua and Barbuda',
          ___AR: 'Argentina',
          ___AM: 'Armenia',
          ___AW: 'Aruba',
          ___AU: 'Australia',
          ___AT: 'Austria',
          ___AZ: 'Azerbaijan',
          ___BS: 'Bahamas',
          ___BH: 'Bahrain',
          ___BD: 'Bangladesh',
          ___BB: 'Barbados',
          ___BY: 'Belarus',
          ___BE: 'Belgium',
          ___BZ: 'Belize',
          ___BJ: 'Benin',
          ___BM: 'Bermuda',
          ___BT: 'Bhutan',
          ___BO: 'Bolivia',
          ___BQ: 'Bonaire, Saint Eustatius and Saba ',
          ___BA: 'Bosnia and Herzegovina',
          ___BW: 'Botswana',
          ___BV: 'Bouvet Island',
          ___BR: 'Brazil',
          ___IO: 'British Indian Ocean Territory',
          ___VG: 'British Virgin Islands',
          ___BN: 'Brunei',
          ___BG: 'Bulgaria',
          ___BF: 'Burkina Faso',
          ___BI: 'Burundi',
          ___KH: 'Cambodia',
          ___CM: 'Cameroon',
          ___CA: 'Canada',
          ___CV: 'Cape Verde',
          ___KY: 'Cayman Islands',
          ___CF: 'Central African Republic',
          ___TD: 'Chad',
          ___CL: 'Chile',
          ___CN: 'China',
          ___CX: 'Christmas Island',
          ___CC: 'Cocos Islands',
          ___CO: 'Colombia',
          ___KM: 'Comoros',
          ___CK: 'Cook Islands',
          ___CR: 'Costa Rica',
          ___HR: 'Croatia',
          ___CU: 'Cuba',
          ___CW: 'Curacao',
          ___CY: 'Cyprus',
          ___CZ: 'Czech Republic',
          ___CD: 'Democratic Republic of the Congo',
          ___DK: 'Denmark',
          ___DJ: 'Djibouti',
          ___DM: 'Dominica',
          ___DO: 'Dominican Republic',
          ___TL: 'East Timor',
          ___EC: 'Ecuador',
          ___EG: 'Egypt',
          ___SV: 'El Salvador',
          ___GQ: 'Equatorial Guinea',
          ___ER: 'Eritrea',
          ___EE: 'Estonia',
          ___ET: 'Ethiopia',
          ___FK: 'Falkland Islands',
          ___FO: 'Faroe Islands',
          ___FJ: 'Fiji',
          ___FI: 'Finland',
          ___FR: 'France',
          ___GF: 'French Guiana',
          ___PF: 'French Polynesia',
          ___TF: 'French Southern Territories',
          ___GA: 'Gabon',
          ___GM: 'Gambia',
          ___GE: 'Georgia',
          ___DE: 'Germany',
          ___GH: 'Ghana',
          ___GI: 'Gibraltar',
          ___GR: 'Greece',
          ___GL: 'Greenland',
          ___GD: 'Grenada',
          ___GP: 'Guadeloupe',
          ___GU: 'Guam',
          ___GT: 'Guatemala',
          ___GG: 'Guernsey',
          ___GN: 'Guinea',
          ___GW: 'Guinea-Bissau',
          ___GY: 'Guyana',
          ___HT: 'Haiti',
          ___HM: 'Heard Island and McDonald Islands',
          ___HN: 'Honduras',
          ___HK: 'Hong Kong',
          ___HU: 'Hungary',
          ___IS: 'Iceland',
          ___IN: 'India',
          ___ID: 'Indonesia',
          ___IR: 'Iran',
          ___IQ: 'Iraq',
          ___IE: 'Ireland',
          ___IM: 'Isle of Man',
          ___IL: 'Israel',
          ___IT: 'Italy',
          ___CI: 'Ivory Coast',
          ___JM: 'Jamaica',
          ___JP: 'Japan',
          ___JE: 'Jersey',
          ___JO: 'Jordan',
          ___KZ: 'Kazakhstan',
          ___KE: 'Kenya',
          ___KI: 'Kiribati',
          ___XK: 'Kosovo',
          ___KW: 'Kuwait',
          ___KG: 'Kyrgyzstan',
          ___LA: 'Laos',
          ___LV: 'Latvia',
          ___LB: 'Lebanon',
          ___LS: 'Lesotho',
          ___LR: 'Liberia',
          ___LY: 'Libya',
          ___LI: 'Liechtenstein',
          ___LT: 'Lithuania',
          ___LU: 'Luxembourg',
          ___MO: 'Macao',
          ___MK: 'Macedonia',
          ___MG: 'Madagascar',
          ___MW: 'Malawi',
          ___MY: 'Malaysia',
          ___MV: 'Maldives',
          ___ML: 'Mali',
          ___MT: 'Malta',
          ___MH: 'Marshall Islands',
          ___MQ: 'Martinique',
          ___MR: 'Mauritania',
          ___MU: 'Mauritius',
          ___YT: 'Mayotte',
          ___MX: 'Mexico',
          ___FM: 'Micronesia',
          ___MD: 'Moldova',
          ___MC: 'Monaco',
          ___MN: 'Mongolia',
          ___ME: 'Montenegro',
          ___MS: 'Montserrat',
          ___MA: 'Morocco',
          ___MZ: 'Mozambique',
          ___MM: 'Myanmar',
          ___NA: 'Namibia',
          ___NR: 'Nauru',
          ___NP: 'Nepal',
          ___NL: 'Netherlands',
          ___NC: 'New Caledonia',
          ___NZ: 'New Zealand',
          ___NI: 'Nicaragua',
          ___NE: 'Niger',
          ___NG: 'Nigeria',
          ___NU: 'Niue',
          ___NF: 'Norfolk Island',
          ___KP: 'North Korea',
          ___MP: 'Northern Mariana Islands',
          ___NO: 'Norway',
          ___OM: 'Oman',
          ___PK: 'Pakistan',
          ___PW: 'Palau',
          ___PS: 'Palestinian Territory',
          ___PA: 'Panama',
          ___PG: 'Papua New Guinea',
          ___PY: 'Paraguay',
          ___PE: 'Peru',
          ___PH: 'Philippines',
          ___PN: 'Pitcairn',
          ___PL: 'Poland',
          ___PT: 'Portugal',
          ___PR: 'Puerto Rico',
          ___QA: 'Qatar',
          ___CG: 'Republic of the Congo',
          ___RE: 'Reunion',
          ___RO: 'Romania',
          ___RU: 'Russia',
          ___RW: 'Rwanda',
          ___BL: 'Saint Barthelemy',
          ___SH: 'Saint Helena',
          ___KN: 'Saint Kitts and Nevis',
          ___LC: 'Saint Lucia',
          ___MF: 'Saint Martin',
          ___PM: 'Saint Pierre and Miquelon',
          ___VC: 'Saint Vincent and the Grenadines',
          ___WS: 'Samoa',
          ___SM: 'San Marino',
          ___ST: 'Sao Tome and Principe',
          ___SA: 'Saudi Arabia',
          ___SN: 'Senegal',
          ___RS: 'Serbia',
          ___SC: 'Seychelles',
          ___SL: 'Sierra Leone',
          ___SG: 'Singapore',
          ___SX: 'Sint Maarten',
          ___SK: 'Slovakia',
          ___SI: 'Slovenia',
          ___SB: 'Solomon Islands',
          ___SO: 'Somalia',
          ___ZA: 'South Africa',
          ___GS: 'South Georgia and the South Sandwich Islands',
          ___KR: 'South Korea',
          ___SS: 'South Sudan',
          ___ES: 'Spain',
          ___LK: 'Sri Lanka',
          ___SD: 'Sudan',
          ___SR: 'Suriname',
          ___SJ: 'Svalbard and Jan Mayen',
          ___SZ: 'Swaziland',
          ___SE: 'Sweden',
          ___CH: 'Switzerland',
          ___SY: 'Syria',
          ___TW: 'Taiwan',
          ___TJ: 'Tajikistan',
          ___TZ: 'Tanzania',
          ___TH: 'Thailand',
          ___TG: 'Togo',
          ___TK: 'Tokelau',
          ___TO: 'Tonga',
          ___TT: 'Trinidad and Tobago',
          ___TN: 'Tunisia',
          ___TR: 'Turkey',
          ___TM: 'Turkmenistan',
          ___TC: 'Turks and Caicos Islands',
          ___TV: 'Tuvalu',
          ___VI: 'U.S. Virgin Islands',
          ___UG: 'Uganda',
          ___UA: 'Ukraine',
          ___AE: 'United Arab Emirates',
          ___GB: 'United Kingdom',
          ___US: 'United States',
          ___UM: 'United States Minor Outlying Islands',
          ___UY: 'Uruguay',
          ___UZ: 'Uzbekistan',
          ___VU: 'Vanuatu',
          ___VA: 'Vatican',
          ___VE: 'Venezuela',
          ___VN: 'Vietnam',
          ___WF: 'Wallis and Futuna',
          ___EH: 'Western Sahara',
          ___YE: 'Yemen',
          ___ZM: 'Zambia',
          ___ZW: 'Zimbabwe'
        }
      }
    },
    global: {
      data: {
        caseDataTypeMetadatas: {
          tag: {
            title: {
              ___intractableDisease: 'D006-4',
              ___designatedIntractableDisease: '指定難病',
              ___pgp: 'Phenotype',
              ___gene_filter: 'Gene Panel',
              ___str: 'STR',
              ___nbs_pathovar: 'Pathogenic Variants',
              ___nbs_nullvar: 'Null Variants',
              ___nbs_carrier: 'Carrier',
              ___incidental: 'Incidental findings',
              ___monitor: 'Monitor',
              ___filter: 'Filter',
              ___clinvar: 'ClinVar',
              ___nbs: 'nbs',
              ___nbs_nonmendelian: 'Nonmendelian'
            }
          }
        },
        predictionMetaDataDisplayTitles: {
          ___Damaging: 'Damaging',
          ___Tolerated: 'Tolerated',
          ___ProbablyDamaging: 'Probably Damaging',
          ___PossiblyDamaging: 'Possibly Damaging',
          ___Benign: 'Benign',
          ___High: 'High',
          ___Medium: 'Medium',
          ___Low: 'Low',
          ___Neutral: 'Neutral',
          ___Splicealtering: 'Splice-altering',
          ___Conserved: 'Conserved',
          ___Nonconserved: 'Non-conserved',
          ___Likelyorpossiblypathogenic: 'Likely or possibly pathogenic',
          ___Likelyorpossiblybenign: 'Likely or possibly benign',
          ___Ambiguous: 'Ambiguous',
          ___Likelybenign: 'Likely benign',
          ___LikelyPathogenic: 'Likely pathogenic'
        },
        getClinvarStatisticData: {
          ___title: 'Coding Impact',
          ___Pathogenic: 'Pathogenic',
          ___Likely_pathogenic: 'Likely Pathogenic',
          ___Conflicting_interpretations_of_pathogenicity: 'Conflicting interpretations of pathogenicity',
          ___Uncertain_significance: 'Uncertain Significance',
          ___Likely_benign: 'Likely benign',
          ___Benign: 'Benign',
          ___stop_gained: 'Stop Gained',
          ___splice_site: 'Splice Site',
          ___frameshift: 'Frameshift Variant',
          ___stop_lost: 'Stop Lost',
          ___start_lost: 'Start Lost',
          ___missense: 'Missense',
          ___inframe_indel: 'Inframe Indel',
          ___synonymous: 'Synonymous Variant',
          ___non_coding: 'Non Coding',
          ___total: 'Total'
        },
        clinvarACMGMap: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___PathogenicLikelypathogenic: 'Pathogenic/Likely pathogenic',
            ___Likelypathogenic: 'Likely pathogenic',
            ___Conflictinginterpretationsofpathogenicity: 'Conflicting interpretations of pathogenicity',
            ___Conflictingclassificationsofpathogenicity: 'Conflicting classifications of pathogenicity',
            ___Uncertainsignificance: 'Uncertain significance',
            ___riskfactor: 'risk factor',
            ___Benign: 'Benign',
            ___BenignLikelybenign: 'Benign/Likely benign',
            ___Likelybenign: 'Likely benign',
            ___drugresponse: 'drug response',
            ___protective: 'protective',
            ___other: 'other',
            ___Affects: 'Affects',
            ___vus: 'VUS'
          },
          display: {
            ___Pathogenic: 'Pathogenic',
            ___PathogenicLikelypathogenic: 'Pathogenic/Likely pathogenic',
            ___Likelypathogenic: 'Likely pathogenic',
            ___Conflictinginterpretationsofpathogenicity: 'Conflicting interpretations of pathogenicity',
            ___Conflictingclassificationsofpathogenicity: 'Conflicting classifications of pathogenicity',
            ___Uncertainsignificance: 'Uncertain significance',
            ___riskfactor: 'risk factor',
            ___Benign: 'Benign',
            ___BenignLikelybenign: 'Benign/Likely benign',
            ___Likelybenign: 'Likely benign',
            ___drugresponse: 'drug response',
            ___protective: 'protective',
            ___other: 'other',
            ___Affects: 'Affects',
            ___vus: 'VUS'
          }
        },
        repeatClassificationMap: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Indeterminate: 'Indeterminate',
            ___Intermediate: 'Intermediate',
            ___Normal: 'Normal'
          }
        },
        acmgMap: {
          info: {
            ___BA1: 'Allele frequency is >5% in population databases.',
            ___BS1: 'Allele frequency is greater than expected for disorder.',
            ___BS2: 'Observed in a healthy adult individual for a recessive (homozygous), dominant (heterozygous), or X-linked (hemizygous) disorder, with full penetrance expected at an early age.',
            ___BS4: 'Lack of segregation in affected members of a family.',
            ___BS3: 'Well-established in vitro or in vivo functional studies show no damaging effect on protein function or splicing.',
            ___BP2: 'Observed in trans with a pathogenic variant for a fully penetrant dominant gene/disorder or observed in cis with a pathogenic variant in any inheritance pattern.',
            ___BP5: 'Variant found in a case with an alternate molecular basis for disease.',
            ___BP1: 'Missense variant in a gene for which primarily truncating variants are known to cause disease.',
            ___BP3: 'In-frame deletions/insertions in a repetitive region without a known function.',
            ___BP4: 'Multiple lines of computational evidence suggest no impact on gene or gene product (conservation, evolutionary, splicing impact, etc.).',
            ___BP7: 'A synonymous (silent) variant for which splicing prediction algorithms predict no impact to the splice consensus sequence nor the creation of a new splice site AND the nucleotide is not highly conserved.',
            ___BP6: 'Reputable source recently reports variant as benign, but the evidence is not available to the laboratory to perform an independent evaluation.',
            ___PP1: 'Cosegregation with disease in multiple affected family members in a gene definitively known to cause the disease.',
            ___PP2: 'Missense variant in a gene that has a low rate of benign missense variation and in which missense variants are a common mechanism of disease.',
            ___PP3: 'Multiple lines of computational evidence support a deleterious effect on the gene or gene product (conservation, evolutionary, splicing impact, etc.).',
            ___PP4: 'Patient’s phenotype or family history is highly specific for a disease with a single genetic etiology.',
            ___PP5: 'Reputable source recently reports variant as pathogenic, but the evidence is not available to the laboratory to perform an independent evaluation.',
            ___PM2: 'Absent from controls (or at extremely low frequency if recessive) in population databases.',
            ___PM3: 'For recessive disorders, detected in trans with a pathogenic variant.',
            ___PM6: 'Assumed de novo, but without confirmation of paternity and maternity.',
            ___PM1: 'Located in a mutational hot spot and/or critical and well-established functional domain (e.g., active site of an enzyme) without benign variation.',
            ___PM4: 'Protein length changes as a result of in-frame deletions/insertions in a nonrepeat region or stop-loss variants.',
            ___PM5: 'Novel missense change at an amino acid residue where a different missense change determined to be pathogenic has been seen before.',
            ___PS4: 'The prevalence of the variant in affected individuals is significantly increased compared with the prevalence in controls.',
            ___PS2: 'De novo (both maternity and paternity confirmed) in a patient with the disease and no family history.',
            ___PS1: 'Same amino acid change as a previously established pathogenic variant regardless of nucleotide change.',
            ___PS3: 'Well-established in vitro or in vivo functional studies supportive of a damaging effect on the gene or gene product.',
            ___PVS1: 'null variant (nonsense, frameshift, canonical ±1 or 2 splice sites, initiation codon, single or multiexon deletion) in a gene where LOF is a known mechanism of disease.'
          },
          explanations: {
            ___BA1: '// EXPLANATIONS',
            ___BS1: '// EXPLANATIONS',
            ___BS2: '// EXPLANATIONS',
            ___BS4: '// EXPLANATIONS',
            ___BS3: '// EXPLANATIONS',
            ___BP2: '// EXPLANATIONS',
            ___BP5: '// EXPLANATIONS',
            ___BP1: '// EXPLANATIONS',
            ___BP3: '// EXPLANATIONS',
            ___BP4: '// EXPLANATIONS',
            ___BP7: '// EXPLANATIONS',
            ___BP6: '// EXPLANATIONS',
            ___PP1: '// EXPLANATIONS',
            ___PP2: '// EXPLANATIONS',
            ___PP3: '// EXPLANATIONS',
            ___PP4: '// EXPLANATIONS',
            ___PP5: '// EXPLANATIONS',
            ___PM2: '// EXPLANATIONS',
            ___PM3: '// EXPLANATIONS',
            ___PM6: '// EXPLANATIONS',
            ___PM1: '// EXPLANATIONS',
            ___PM4: '// EXPLANATIONS',
            ___PM5: '// EXPLANATIONS',
            ___PS4: '// EXPLANATIONS',
            ___PS2: '// EXPLANATIONS',
            ___PS1: '// EXPLANATIONS',
            ___PS3: '// EXPLANATIONS',
            ___PVS1: '// EXPLANATIONS'
          }
        },
        datasetStatusMap: {
          title: {
            ___created: 'created',
            ___analyzing: 'Analyzing…',
            ___completed: 'Done',
            ___failed: 'Failed',
            ___disabled: 'Disabled'
          }
        },
        datasetPermissionTypeMap: {
          title: {
            ___private: 'Private',
            ___community: 'Community'
          }
        },
        datasetPermissionMap: {
          title: {
            ___private: 'Private',
            ___basic: 'Basic',
            ___explore: 'Data Explore',
            ___full: 'Full access'
          }
        },
        datasetInvitationPermissionMap: {
          title: {
            ___explore: 'Data Explore',
            ___full: 'Full access'
          }
        },
        datasetPipelineMap: {
          title: {
            ___WES: 'Whole Exome Sequencing',
            ___WGS: 'Whole Genome Sequencing'
          }
        },
        datasetShareAlert: {
          ___external_data_included: 'Because it contains community data. If you want to share dataset, create a dataset with all your data.',
          ___disabled: 'Because dataset is disable',
          ___analyzing: 'Because data analysis is processing',
          ___failed: 'Because data analysis is failed'
        },
        windowConfirm: {
          ___default: 'Do you really want to leave? you have unsaved changes!'
        },
        defaultEmptyDisplay: {
          ___empty: 'N/A',
          ___noKey: '?'
        },
        pageDisplay: {
          ___item: '{count} item | {count} items',
          ___display: 'Items per page',
          ___jump: 'Go to',
          ___page: 'Page'
        },
        projectState: {
          ___created: 'no data',
          ___uploading: 'Uploading',
          ___analyzing: 'Analyzing',
          ___completed: 'Completed',
          ___failed: 'Analysis Failed',
          ___noAffected: 'Not affected'
        },
        jobState: {
          ___running: 'Pipeline',
          ___default: 'Phenotype'
        },
        familyRelationOptions: {
          title: {
            ___Father: 'Father',
            ___Mother: 'Mother',
            ___Brother: 'Brother',
            ___Sister: 'Sister',
            ___PaternalGrandfather: 'Paternal Grandfather',
            ___PaternalGrandmother: 'Paternal Grandmother',
            ___MaternalGrandfather: 'Maternal Grandfather',
            ___MaternalGrandmother: 'Maternal Grandmother',
            ___PaternalUncle: 'Paternal Uncle',
            ___PaternalAunt: 'Paternal Aunt',
            ___MaternalUncle: 'Maternal Uncle',
            ___MaternalAunt: 'Maternal Aunt'
          }
        },
        svClinvarOptions: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Variant_of_Uncertain_Significance: 'Uncertain Significance',
            ___Conflicting_interpretations_of_pathogenicity: 'Conflicting interpretations of pathogenicity'
          },
          subtitle: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Variant_of_Uncertain_Significance: 'Uncertain Significance',
            ___Conflicting_interpretations_of_pathogenicity: 'Conflicting interpretations of pathogenicity'
          }
        },
        svDECIPHEROptions: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Uncertain_Significance: 'Uncertain Significance',
            ___Others: 'Others'
          },
          subtitle: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Uncertain_Significance: 'Uncertain Significance',
            ___Others: 'Others'
          }
        },
        svDosageSensitivityOptions: {
          title: {
            ___Sufficient_evidence_for_dosage_pathogenicity: 'Sufficient evidence for dosage pathogenicity',
            ___Some_evidence_for_dosage_pathogenicity: 'Some evidence for dosage pathogenicity',
            ___Little_evidence_for_dosage_pathogenicity: 'Little evidence for dosage pathogenicity',
            ___No_evidence_for_dosage_pathogenicity: 'No evidence for dosage pathogenicity',
            ___Evidence_suggests_the_gene_is_not_dosage_sensitive: 'Evidence suggests the gene is not dosage sensitive',
            ___Gene_associated_with_autosomal_recessive_phenotype: 'Gene associated with autosomal recessive phenotype'
          }
        },
        svGenotypeOptions: {
          title: {
            ___Homozygous_reference: 'Homozygous reference',
            ___Heterozygous: 'Heterozygous',
            ___Homozygous_alternate: 'Homozygous alternate'
          }
        },
        svTypeOptions: {
          title: {
            ___DEL: 'DEL',
            ___INS: 'INS',
            ___DUP: 'DUP',
            ___INV: 'INV',
            ___CNV: 'CNV',
            ___BND: 'BND'
          }
        },
        strClassificationMap: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Indeterminate: 'Indeterminate',
            ___Intermediate: 'Intermediate',
            ___Normal: 'Normal'
          }
        },
        intractableDiseaseDifficutyMap: {
          title: {
            ___easy: '処理が容易なもの',
            ___hard: '処理が複雑なもの',
            ___very_hard: '処理が極めて複雑なもの'
          }
        },
        intractableDiseaseMethodMap: {
          title: {
            ___A: 'ア',
            ___I: 'イ',
            ___U: 'ウ',
            ___E: 'エ',
            ___O: 'オ'
          },
          info: {
            ___A: '<span>ＰＣＲ法、ＤＮＡシーケンス法、ＦＩＳＨ法又はサザンブロット法による場合に算定できるもの</span>',
            ___I: '<span>ＰＣＲ法による場合に算定できるもの</span>',
            ___U: '<span>ア、イ、エ及びオ以外のもの</span>',
            ___E: '<span>別に<a href=http://www.kentaikensa.jp/files/37089.pdf target=_blank>厚生労働大臣が定める施設基準に適合しているものとして地方厚生（支）局長に届け出</a>た保険医療機関において検査が行われる場合に算定できるもの</span>',
            ___O: '<span>臨床症状や他の検査等では診断がつかない場合に、別に<a href=http://www.kentaikensa.jp/files/37089.pdf target=_blank>厚生労働大臣が定める施設基準に適合しているものとして地方厚生（支）局長に届け出</a>た保険医療機関において検査が行われる場合に算定できるもの</span>'
          }
        },
        intractableDiseaseOptions: {
          title: {
            ___Duchenne_muscular_dystrophy: 'Duchenne muscular dystrophy',
            ___Becker_muscular_dystrophy: 'Becker muscular dystrophy',
            ___Familial_amyloidosis: 'Familial amyloidosis',
            ___Spinal_and_bulbar_muscular_atrophy_SBMA: 'Spinal and bulbar muscular atrophy (SBMA)',
            ___Myotonic_dystrophy: 'Myotonic dystrophy',
            ___Lysosomal_storage_diseases_including_mucopolysaccharidosis_type_I_mucopolysaccharidosis_type_II_Gaucher_disease_Fabry_disease_and_Pompe_disease: 'Lysosomal storage diseases (including mucopolysaccharidosis type I, mucopolysaccharidosis type II, Gaucher disease, Fabry disease, and Pompe disease)',
            ___Fragile_X_syndrome: 'Fragile X syndrome',
            ___TNF_receptor_associated_periodic_syndrome_TRAPS: 'TNF receptor-associated periodic syndrome (TRAPS)',
            ___Nakajo_Nishimura_syndrome: 'Nakajo-Nishimura syndrome',
            ___Familial_Mediterranean_fever: 'Familial Mediterranean fever',
            ___Bethlem_myopathy: 'Bethlem myopathy',
            ___X_linked_myopathy_with_excessive_autophagy: 'X-linked myopathy with excessive autophagy',
            ___Non_dystrophic_myotonia_syndromes: 'Non-dystrophic myotonia syndromes',
            ___Hereditary_periodic_limb_paralysis: 'Hereditary periodic (limb) paralysis',
            ___Autosomal_recessive_leukodystrophy_with_alopecia_and_spondylometaphyseal_dysplasia: 'Autosomal recessive leukodystrophy with alopecia and spondylometaphyseal dysplasia',
            ___Tuberous_sclerosis: 'Tuberous sclerosis',
            ___Pachydermoperiostosis: 'Pachydermoperiostosis',
            // ___Neurofibromatosis_Type_I: 'Neurofibromatosis Type I',
            // ___Neurofibromatosis_Type_2: 'Neurofibromatosis Type 2',
            ___Alexander_disease: 'Alexander disease',
            ___Chronic_non_specific_multiple_ulcers_of_the_small_intestine: 'Chronic non-specific multiple ulcers of the small intestine',
            ___TRPV4_related_disorder: 'TRPV4-related disorder',
            ___Fukuyama_congenital_muscular_dystrophy: 'Fukuyama congenital muscular dystrophy',
            ___Spinal_muscular_atrophy: 'Spinal muscular atrophy',
            ___Huntingtons_disease: 'Huntington\'s disease',
            ___Retinoblastoma: 'Retinoblastoma',
            ___Medullary_thyroid_carcinoma: 'Medullary thyroid carcinoma',
            ___Multiple_endocrine_neoplasia_type_1_MEN1: 'Multiple endocrine neoplasia type 1 (MEN1)',
            ___Phenylketonuria_PKU: 'Phenylketonuria (PKU)',
            ___Homocystinuria: 'Homocystinuria',
            ___Citrullinemia_type_I: 'Citrullinemia type I',
            ___Argininosuccinic_aciduria_Urea_cycle_disorder: 'Argininosuccinic aciduria (Urea cycle disorder)',
            ___Isovaleric_acidemia: 'Isovaleric acidemia',
            ___HMG_CoA_lyase_deficiency: 'HMG-CoA lyase deficiency',
            ___Multiple_carboxylase_deficiency: 'Multiple carboxylase deficiency',
            ___Glutaric_acidemia_type_1: 'Glutaric acidemia type 1',
            ___MCAD_deficiency_Medium_chain_acyl_CoA_dehydrogenase_deficiency: 'MCAD deficiency (Medium-chain acyl-CoA dehydrogenase deficiency)',
            ___VLCAD_deficiency_Very_long_chain_acyl_CoA_dehydrogenase_deficiency: 'VLCAD deficiency (Very long-chain acyl-CoA dehydrogenase deficiency)',
            ___CPT1_deficiency_Carnitine_palmitoyltransferase_I_deficiency: 'CPT1 deficiency (Carnitine palmitoyltransferase I deficiency)',
            // ___Menkes_Disease_Congenital_disorder_of_copper_metabolism: 'Menkes Disease (Congenital disorder of copper metabolism)',
            // ___Occipital_Horn_Syndrome_Congenital_disorder_of_copper_metabolism: 'Occipital Horn Syndrome (Congenital disorder of copper metabolism)',
            // ___Wilson_Disease_Congenital_disorder_of_copper_metabolism: 'Wilson Disease (Congenital disorder of copper metabolism)',
            ___Cryopyrin_associated_periodic_syndromes_CAPS: 'Cryopyrin-associated periodic syndromes (CAPS)',
            ___Neurodegeneration_with_brain_iron_accumulation_NBIA: 'Neurodegeneration with brain iron accumulation (NBIA)',
            ___Congenital_cerebral_leukodystrophy_including_central_nervous_system_hypomyelination: 'Congenital cerebral leukodystrophy (including central nervous system hypomyelination)',
            ___PCDH19_related_disorder: 'PCDH19-related disorder',
            ___Hypophosphatasia: 'Hypophosphatasia',
            ___Apert_syndrome: 'Apert syndrome',
            ___Rothmund_Thomson_syndrome: 'Rothmund-Thomson syndrome',
            ___Prader_Willi_syndrome: 'Prader-Willi syndrome',
            ___Angelman_syndrome: 'Angelman syndrome',
            ___Smith_Magenis_syndrome: 'Smith-Magenis syndrome',
            ___Fragile_X_associated_disorders: 'Fragile X-associated disorders',
            ___Wolfram_syndrome: 'Wolfram syndrome',
            ___Hyper_IgD_syndrome: 'Hyper IgD syndrome',
            ___PAPA_syndrome_Pyogenic_sterile_arthritis_pyoderma_gangrenosum_and_acne: 'PAPA syndrome (Pyogenic sterile arthritis, pyoderma gangrenosum, and acne)',
            ___Congenital_anomaly_syndromes: 'Congenital anomaly syndromes',
            ___ACTH_resistance_syndrome: 'ACTH resistance syndrome',
            ___Autosomal_recessive_punctate_epiphyseal_dysplasia_type_1_Peroxisomal_diseases_excluding_adrenoleukodystrophy: 'Autosomal recessive punctate epiphyseal dysplasia type 1(Peroxisomal diseases (excluding adrenoleukodystrophy))',
            ___Familial_partial_lipodystrophy: 'Familial partial lipodystrophy',
            ___Sotos_syndrome: 'Sotos syndrome',
            ___Carnitine_deficiency_Carnitine_palmitoyltransferase_II_deficiency: 'Carnitine deficiency (Carnitine palmitoyltransferase II deficiency)',
            ___Carnitine_deficiency_Carnitine_acylcarnitine_translocase_deficiency: 'Carnitine deficiency (Carnitine-acylcarnitine translocase deficiency)',
            ___Carnitine_deficiency_OCTN2_deficiency_Primary_carnitine_deficiency: 'Carnitine deficiency (OCTN2 deficiency (Primary carnitine deficiency))',
            ___Citrin_deficiency: 'Citrin deficiency',
            ___Non_ketotic_hyperglycinemia: 'Non-ketotic hyperglycinemia',
            ___Beta_ketothiolase_deficiency: 'Beta-ketothiolase deficiency',
            ___3_Methylglutaconic_aciduria: '3-Methylglutaconic aciduria',
            ___Glutaric_acidemia_type_2: 'Glutaric acidemia type 2',
            ___Congenital_adrenal_hypoplasia: 'Congenital adrenal hypoplasia',
            ___ATR_X_syndrome_Alpha_thalassemia_X_linked_intellectual_disability_syndrome: 'ATR-X syndrome (Alpha-thalassemia X-linked intellectual disability syndrome)',
            ___Hutchinson_Gilford_progeria_syndrome: 'Hutchinson-Gilford progeria syndrome',
            ___Achondroplasia: 'Achondroplasia',
            ___Progressive_Myoclonic_Epilepsy_Lafora_disease: 'Progressive Myoclonic Epilepsy (Lafora disease)',
            ___Sepiapterin_reductase_SR_deficiency: 'Sepiapterin reductase (SR) deficiency',
            ___Aromatic_L_amino_acid_decarboxylase_deficiency: 'Aromatic L-amino acid decarboxylase deficiency',
            ___Osler_disease_Hereditary_hemorrhagic_telangiectasia: 'Osler disease (Hereditary hemorrhagic telangiectasia)',
            ___CFC_syndrome_Cardiofaciocutaneous_syndrome: 'CFC syndrome (Cardiofaciocutaneous syndrome)',
            ___Costello_syndrome: 'Costello syndrome',
            ___CHARGE_syndrome: 'CHARGE syndrome',
            ___Lysinuric_protein_intolerance: 'Lysinuric protein intolerance',
            ___Adrenoleukodystrophy: 'Adrenoleukodystrophy',
            ___Blau_syndrome: 'Blau syndrome',
            ___Branchio_oto_renal_syndrome: 'Branchio-oto-renal syndrome',
            ___Young_Simpson_syndrome: 'Young-Simpson syndrome',
            ___Congenital_nephrogenic_diabetes_insipidus: 'Congenital nephrogenic diabetes insipidus',
            ___Vitamin_D_dependent_rickets_osteomalacia: 'Vitamin D-dependent rickets/osteomalacia',
            ___Nail_patella_syndrome_LMX1B_associated_nephropathy: 'Nail-patella syndrome / LMX1B-associated nephropathy',
            ___GLUT1_deficiency_syndrome: 'GLUT1 deficiency syndrome',
            ___Resistance_to_thyroid_hormone: 'Resistance to thyroid hormone',
            ___Weaver_syndrome: 'Weaver syndrome',
            ___Coffin_Lowry_syndrome: 'Coffin-Lowry syndrome',
            ___Mowat_Wilson_syndrome: 'Mowat-Wilson syndrome',
            ___Hepatic_glycogen_storage_diseases_types_I_III_VI_IXa_IXb_IXc_IV: 'Hepatic glycogen storage diseases (types I, III, VI, IXa, IXb, IXc, IV)',
            ___Myopathic_glycogen_storage_diseases_types_III_IV_IXd: 'Myopathic glycogen storage diseases (types III, IV, IXd)',
            ___Congenital_protein_C_deficiency: 'Congenital protein C deficiency',
            ___Congenital_protein_S_deficiency: 'Congenital protein S deficiency',
            ___Congenital_antithrombin_deficiency: 'Congenital antithrombin deficiency',
            ___Amyotrophic_lateral_sclerosis_ALS: 'Amyotrophic lateral sclerosis (ALS)',
            ___Distal_myopathy_with_rimmed_vacuoles: 'Distal myopathy with rimmed vacuoles',
            ___Schwartz_Jampel_syndrome: 'Schwartz-Jampel syndrome',
            ___Hypertrophic_cardiomyopathy: 'Hypertrophic cardiomyopathy',
            ___Familial_hypercholesterolemia_holmozygous: 'Familial hypercholesterolemia (holmozygous)',
            ___Congenital_myopathy: 'Congenital myopathy',
            ___CADASIL_Cerebral_autosomal_dominant_arteriopathy_with_subcortical_infarcts_and_leukoencephalopathy: 'CADASIL (Cerebral autosomal dominant arteriopathy with subcortical infarcts and leukoencephalopathy)',
            ___Hereditary_diffuse_leukoencephalopathy_with_axonal_spheroids: 'Hereditary diffuse leukoencephalopathy with axonal spheroids',
            ___Congenital_insensitivity_to_pain_with_anhidrosis: 'Congenital insensitivity to pain with anhidrosis',
            ___Familial_benign_chronic_pemphigus_Hailey_Hailey_disease: 'Familial benign chronic pemphigus (Hailey-Hailey disease)',
            ___Nasu_Hakola_disease: 'Nasu-Hakola disease',
            ___Carney_complex: 'Carney complex',
            ___Peroxisome_biogenesis_disorder: 'Peroxisome biogenesis disorder',
            ___Peroxisomal_beta_oxidation_enzyme_deficiency: 'Peroxisomal beta-oxidation enzyme deficiency',
            ___Plasmalogen_synthesis_enzyme_deficiency: 'Plasmalogen synthesis enzyme deficiency',
            ___Acatalasemia: 'Acatalasemia',
            ___Primary_hyperoxaluria_type_I: 'Primary hyperoxaluria type I',
            ___Refsum_disease: 'Refsum disease',
            ___Hereditary_folate_malabsorption: 'Hereditary folate malabsorption',
            ___Atypical_porphyria: 'Atypical porphyria',
            ___Congenital_erythropoietic_porphyria: 'Congenital erythropoietic porphyria',
            ___Acute_intermittent_porphyria: 'Acute intermittent porphyria',
            ___Erythropoietic_protoporphyria: 'Erythropoietic protoporphyria',
            ___X_linked_protoporphyria: 'X-linked protoporphyria',
            ___Hereditary_coproporphyria: 'Hereditary coproporphyria',
            ___Porphyria_cutanea_tarda: 'Porphyria cutanea tarda',
            ___Hepatoerythropoietic_porphyria: 'Hepatoerythropoietic porphyria',
            ___Primary_hyperchylomicronemia: 'Primary hyperchylomicronemia',
            ___Abetalipoproteinemia: 'Abetalipoproteinemia',
            ___Thanatophoric_dysplasia: 'Thanatophoric dysplasia',
            ___Hereditary_pancreatitis: 'Hereditary pancreatitis',
            ___Cystic_fibrosis: 'Cystic fibrosis',
            ___Usher_syndrome_type_1_type_2_type_3: 'Usher syndrome (type 1, type 2, type 3)',
            ___Canavan_disease: 'Canavan disease',
            ___Congenital_glycosylphosphatidylinositol_deficiency: 'Congenital glycosylphosphatidylinositol deficiency',
            ___Osteopetrosis: 'Osteopetrosis',
            ___Cerebral_creatine_deficiency_syndrome: 'Cerebral creatine deficiency syndrome',
            ___Nephronophthisis: 'Nephronophthisis',
            ___Familial_hypobetalipoproteinemia_type_1_homozygous_form: 'Familial hypobetalipoproteinemia type 1 (homozygous form)',
            ___Progressive_familial_intrahepatic_cholestasis: 'Progressive familial intrahepatic cholestasis',
            ___Nutritional_epidermolysis_bullosa: 'Nutritional epidermolysis bullosa',
            ___Congenital_long_QT_syndrome: 'Congenital long QT syndrome',
            ___Maple_syrup_urine_disease: 'Maple syrup urine disease',
            ___Methylmalonic_acidemia: 'Methylmalonic acidemia',
            ___Propionic_acidemia: 'Propionic acidemia',
            ___3_Methylcrotonylglycinuria: '3-Methylcrotonylglycinuria',
            ___MTP_LCHAD_deficiency_Triple_Enzyme_Deficiency: 'MTP (LCHAD) deficiency (Triple Enzyme Deficiency)',
            ___Xeroderma_pigmentosum: 'Xeroderma pigmentosum',
            ___Loeys_Dietz_syndrome: 'Loeys-Dietz syndrome',
            ___Familial_thoracic_aortic_aneurysm_and_dissection: 'Familial thoracic aortic aneurysm and dissection',
            ___Neuroacanthocytosis: 'Neuroacanthocytosis',
            ___Congenital_myasthenic_syndrome: 'Congenital myasthenic syndrome',
            ___Primary_immunodeficiency_syndrome: 'Primary immunodeficiency syndrome',
            ___Perry_syndrome: 'Perry syndrome',
            ___Crouzon_syndrome: 'Crouzon syndrome',
            ___Pfeiffer_syndrome: 'Pfeiffer syndrome',
            ___Antley_Bixler_syndrome: 'Antley-Bixler syndrome',
            ___Tangier_disease: 'Tangier disease',
            ___Congenital_dyserythropoietic_anemia: 'Congenital dyserythropoietic anemia',
            ___Early_onset_bilateral_sensorineural_hearing_loss: 'Early-onset bilateral sensorineural hearing loss',
            ___Urea_cycle_disorder: 'Urea cycle disorder',
            ___Marfan_syndrome_Loeys_Dietz_Syndrome: 'Marfan syndrome/Loeys-Dietz Syndrome',
            ___Vascular_Ehlers_Danlos_syndrome: 'Vascular Ehlers-Danlos syndrome',
            ___Hereditary_autoinflammatory_disease: 'Hereditary autoinflammatory disease',
            ___Hereditary_dystonia: 'Hereditary dystonia',
            ___Dravet_syndrome: 'Dravet syndrome',
            ___Coffin_Siris_syndrome: 'Coffin-Siris syndrome',
            ___Kabuki_syndrome: 'Kabuki syndrome',
            ___Pulmonary_alveolar_proteinosis_autoimmune_or_congenital: 'Pulmonary alveolar proteinosis (autoimmune or congenital)',
            ___Noonan_syndrome: 'Noonan syndrome',
            ___Osteogenesis_imperfecta: 'Osteogenesis imperfecta',
            ___Spinocerebellar_degeneration_excluding_multiple_system_atrophy: 'Spinocerebellar degeneration (excluding multiple system atrophy)',
            ___Classical_Ehlers_Danlos_syndrome: 'Classical Ehlers-Danlos syndrome',
            ___Atypical_hemolytic_uremic_syndrome_aHUS: 'Atypical hemolytic uremic syndrome (aHUS)',
            ___Alport_syndrome: 'Alport syndrome',
            ___Fanconi_anemia: 'Fanconi anemia',
            ___Alagille_syndrome: 'Alagille syndrome',
            ___Rubinstein_Taybi_syndrome: 'Rubinstein-Taybi syndrome',
            ___Primary_ciliary_dyskinesia_including_Kartagener_syndrome: 'Primary ciliary dyskinesia (including Kartagener syndrome)',
            ___Proteinuria_group: 'Proteinuria group',
            ___Cardiomyopathy_group: 'Cardiomyopathy group',
            ___Growth_disorder_intellectual_disability_and_characteristic_facial_features_group: 'Growth disorder, intellectual disability, and characteristic facial features group',
            ___Intellectual_disability_and_epilepsy_group: 'Intellectual disability and epilepsy group',
            ___Fever_inflammation_rash_and_osteoarticular_syndrome_group: 'Fever, inflammation, rash, and osteoarticular syndrome group',
            ___Muscle_weakness_group: 'Muscle weakness group',
            ___Rett_syndrome: 'Rett syndrome',
            ___Lowe_syndrome_oculocerebrorenal_syndrome: 'Lowe syndrome (oculocerebrorenal syndrome)',
            ___Miyoshi_myopathy: 'Miyoshi myopathy',
            ___Lecithin_cholesterol_acyltransferase_LCAT_deficiency: 'Lecithin-cholesterol acyltransferase (LCAT) deficiency',
            ___Sitosterolemia: 'Sitosterolemia',
            ___Pseudohypoparathyroidism: 'Pseudohypoparathyroidism',
            ___Marinesco_Sjögren_syndrome: 'Marinesco-Sjögren syndrome',
            ___Galactose_1_phosphate_uridyltransferase_deficiency: 'Galactose-1-phosphate uridyltransferase deficiency',
            ___Fibrodysplasia_ossificans_progressiva_FOP: 'Fibrodysplasia ossificans progressiva (FOP)',
            ___Aniridia: 'Aniridia',
            ___PURA_related_neurodevelopmental_disorders: 'PURA-related neurodevelopmental disorders',
            ___Leber_hereditary_optic_neuropathy_LHON: 'Leber hereditary optic neuropathy (LHON)',
            ___Alveolar_hypoventilation_syndrome: 'Alveolar hypoventilation syndrome',
            ___Cerebrotendinous_xanthomatosis_CTX: 'Cerebrotendinous xanthomatosis (CTX)',
            ___Joubert_syndrome_and_related_disorders_JSRD: 'Joubert syndrome and related disorders (JSRD)',
            ___Werner_syndrome: 'Werner syndrome',
            ___Cockayne_syndrome: 'Cockayne syndrome',
            ___Pseudoxanthoma_elasticum_PXE: 'Pseudoxanthoma elasticum (PXE)',
            ___Diamond_Blackfan_anemia: 'Diamond-Blackfan anemia',
            ___LMNB1_related_leukoencephalopathy_ADLD: 'LMNB1-related leukoencephalopathy (ADLD)',
            ___Congenital_ichthyosis: 'Congenital ichthyosis',
            ___Oculocutaneous_albinism: 'Oculocutaneous albinism',
            ___STING_stimulator_of_interferon_genes_associated_vasculopathy_with_onset_in_infancy: 'STING (stimulator of interferon genes)-associated vasculopathy with onset in infancy',
            ___Progressive_leukoencephalopathy: 'Progressive leukoencephalopathy',
            ___Charcot_Marie_Tooth_disease_CMT: 'Charcot-Marie-Tooth disease (CMT)',
            ___Congenital_adrenal_hyperplasia_congenital_adrenal_enzyme_deficiency: 'Congenital adrenal hyperplasia (congenital adrenal enzyme deficiency)',
            ___Hemorrhagic_disorders_due_to_abnormal_fibrinolysis: 'Hemorrhagic disorders due to abnormal fibrinolysis',
            ___Mitochondrial_diseases: 'Mitochondrial diseases',
            ___Epstein_syndrome: 'Epstein syndrome',
            ___neurofibromatosis: 'Neurofibromatosis',
            ___congenital_hearing_loss: 'Congenital hearing loss',
            ___prion_disease: 'Prion disease',
            ___familial_idiopathic_basal_ganglia_calcification: 'Familial idiopathic basal ganglia calcification',
            ___williams_syndrome: 'Williams syndrome',
            ___1p36_deletion_syndrome: '1p36 deletion syndrome',
            ___4p_deletion_syndrome: '4p deletion syndrome',
            ___5p_deletion_syndrome: '5p deletion syndrome',
            ___paternal_uniparental_disomy_of_chromosome_14: 'Paternal uniparental disomy of chromosome 14',
            ___22q11_2_deletion_syndrome: '22q11.2 deletion syndrome',
            ___unverricht_lundborg_disease: 'Unverricht-Lundborg disease',
            ___congenital_disorder_of_copper_metabolism: 'Congenital disorder of copper metabolism',
            ___hereditary_sideroblastic_anemia: 'Hereditary sideroblastic anemia',
            ___ring_chromosome_20_syndrome: 'Ring chromosome 20 syndrome',
            ___emanuel_syndrome: 'Emanuel syndrome',
            ___dermatofibrosarcoma_protuberans: 'Dermatofibrosarcoma protuberans',
            ___Primary_lateral_sclerosis: 'Primary lateral sclerosis',
            ___Progressive_supranuclear_palsy: 'Progressive supranuclear palsy',
            ___Parkinsons_disease: 'Parkinson\'s disease',
            ___Corticobasal_degeneration: 'Corticobasal degeneration',
            ___Charcot_Marie_Tooth_disease: 'Charcot-Marie-Tooth disease',
            ___Myasthenia_gravis: 'Myasthenia gravis',
            ___Multiple_sclerosis_Neuromyelitis_optica_spectrum_disorders: 'Multiple sclerosis/Neuromyelitis optica spectrum disorders',
            ___Chronic_inflammatory_demyelinating_polyneuropathy_Multifocal_motor_neuropathy: 'Chronic inflammatory demyelinating polyneuropathy/Multifocal motor neuropathy',
            ___Sporadic_inclusion_body_myositis: 'Sporadic inclusion body myositis',
            ___Multiple_system_atrophy: 'Multiple system atrophy',
            ___Moyamoya_disease: 'Moyamoya disease',
            ___Pemphigus: 'Pemphigus',
            ___Pustular_psoriasis: 'Pustular psoriasis',
            ___Stevens_Johnson_syndrome: 'Stevens-Johnson syndrome',
            ___Toxic_epidermal_necrolysis: 'Toxic epidermal necrolysis',
            ___Takayasu_arteritis: 'Takayasu arteritis',
            ___Giant_cell_arteritis: 'Giant cell arteritis',
            ___Polyarteritis_nodosa: 'Polyarteritis nodosa',
            ___Granulomatosis_with_polyangiitis: 'Granulomatosis with polyangiitis',
            ___Systemic_lupus_erythematosus: 'Systemic lupus erythematosus',
            ___Systemic_sclerosis: 'Systemic sclerosis',
            ___Behcets_disease: 'Behcet\'s disease',
            ___Idiopathic_dilated_cardiomyopathy: 'Idiopathic dilated cardiomyopathy',
            ___Restrictive_cardiomyopathy: 'Restrictive cardiomyopathy',
            ___Aplastic_anemia: 'Aplastic anemia',
            ___Paroxysmal_nocturnal_hemoglobinuria: 'Paroxysmal nocturnal hemoglobinuria',
            ___Immune_thrombocytopenia: 'Immune thrombocytopenia',
            ___Thrombotic_thrombocytopenic_purpura: 'Thrombotic thrombocytopenic purpura',
            ___IgA_nephropathy: 'IgA nephropathy',
            ___Polycystic_kidney_disease: 'Polycystic kidney disease',
            ___Ossification_of_posterior_longitudinal_ligament: 'Ossification of posterior longitudinal ligament',
            ___Idiopathic_osteonecrosis_of_femoral_head: 'Idiopathic osteonecrosis of femoral head',
            ___Diencephalo_hypophysial_insufficiency_inappropriate_ADH_syndrome: 'Diencephalo-hypophysial insufficiency-inappropriate ADH syndrome',
            ___Diencephalo_hypophysial_insufficiency_inappropriate_thyroid_stimulating_hormone_syndrome: 'Diencephalo-hypophysial insufficiency-inappropriate thyroid stimulating hormone syndrome',
            ___Diencephalo_hypophysial_insufficiency_inappropriate_prolactin_syndrome: 'Diencephalo-hypophysial insufficiency-inappropriate prolactin syndrome',
            ___Cushing_disease: 'Cushing disease',
            ___Diencephalo_hypophysial_dysfunction_syndrome_of_abnormal_secretion_of_gonadotropin: 'Diencephalo-hypophysial dysfunction-syndrome of abnormal secretion of gonadotropin',
            ___Diencephalo_hypophysial_dysfunction_syndrome_of_abnormal_secretion_of_growth_hormone: 'Diencephalo-hypophysial dysfunction-syndrome of abnormal secretion of growth hormone',
            ___Hypopituitarism_syndrome: 'Hypopituitarism syndrome',
            ___Congenital_adrenal_enzyme_deficiency: 'Congenital adrenal enzyme deficiency',
            ___Addisons_disease: 'Addison\'s disease',
            ___Sarcoidosis: 'Sarcoidosis',
            ___Pulmonary_arterial_hypertension: 'Pulmonary arterial hypertension',
            ___Pulmonary_veno_occlusive_disease_pulmonary_capillary_hemangiomatosis: 'Pulmonary veno-occlusive disease / pulmonary capillary hemangiomatosis',
            ___Chronic_thromboembolic_pulmonary_hypertension: 'Chronic thromboembolic pulmonary hypertension',
            ___Lymphangioleiomyomatosis: 'Lymphangioleiomyomatosis',
            ___Retinitis_pigmentosa: 'Retinitis pigmentosa',
            ___Budd_Chiari_syndrome: 'Budd-Chiari syndrome',
            ___Primary_biliary_cholangitis: 'Primary biliary cholangitis',
            ___Primary_sclerosing_cholangitis: 'Primary sclerosing cholangitis',
            ___Crohns_disease: 'Crohn\'s disease',
            ___Ulcerative_colitis: 'Ulcerative colitis',
            ___Chronic_idiopathic_intestinal_pseudo_obstruction: 'Chronic idiopathic intestinal pseudo-obstruction',
            ___Megacystis_microcolon_intestinal_hypoperistalsis_syndrome: 'Megacystis-microcolon-intestinal hypoperistalsis syndrome',
            ___Juvenile_idiopathic_arthritis: 'Juvenile idiopathic arthritis',
            ___Marinesco_Sjogren_syndrome: 'Marinesco-Sjogren syndrome',
            ___Myelomeningocele: 'Myelomeningocele',
            ___Frontotemporal_lobar_degeneration: 'Frontotemporal lobar degeneration',
            ___Acute_encephalopathy_with_biphasic_seizures_and_late_reduced_diffusion: 'Acute encephalopathy with biphasic seizures and late reduced diffusion',
            ___Moebius_syndrome: 'Moebius syndrome',
            ___Septo_optic_dysplasia_De_Morsier_syndrome: 'Septo-optic dysplasia / De Morsier syndrome',
            ___Aicardi_syndrome: 'Aicardi syndrome',
            ___Hemimegalencephaly: 'Hemimegalencephaly',
            ___Focal_cortical_dysplasia: 'Focal cortical dysplasia',
            ___Neuronal_migration_defects: 'Neuronal migration defects',
            ___Epilepsy_with_myoclonic_atonic_seizures: 'Epilepsy with myoclonic atonic seizures',
            ___Lennox_Gastaut_syndrome: 'Lennox-Gastaut syndrome',
            ___West_syndrome: 'West syndrome',
            ___Ohtahara_syndrome: 'Ohtahara syndrome',
            ___Early_myoclonic_encephalopathy: 'Early myoclonic encephalopathy',
            ___Epilepsy_of_infancy_with_migrating_focal_seizures: 'Epilepsy of infancy with migrating focal seizures',
            ___Hemiconvulsion_hemiplegia_epilepsy_syndrome: 'Hemiconvulsion-hemiplegia-epilepsy syndrome',
            ___Rasmussens_encephalitis: 'Rasmussen\'s encephalitis',
            ___Developmental_and_or_epileptic_encephalopathy_with_spike_wave_activation_in_sleep: 'Developmental and/or epileptic encephalopathy with spike-wave activation in sleep',
            ___Landau_Kleffner_syndrome: 'Landau-Kleffner syndrome',
            // ___Rett_syndrome: 'Rett syndrome',
            ___Sturge_Weber_syndrome: 'Sturge-Weber syndrome',
            // ___Congenital_ichthyosis: 'Congenital ichthyosis',
            ___Pemphigoid_including_Epidermolysis_bullosa_acquisita: 'Pemphigoid (including Epidermolysis bullosa acquisita)',
            // ___Oculocutaneous_albinism: 'Oculocutaneous albinism',
            ___Pseudoxanthoma_elasticum: 'Pseudoxanthoma elasticum',
            ___VATER_syndrome: 'VATER syndrome',
            ___Joubert_syndrome_and_related_disorders: 'Joubert syndrome and related disorders',
            ___Polysplenia_syndrome: 'Polysplenia syndrome',
            ___Asplenia_syndrome: 'Asplenia syndrome',
            // ___Werner_syndrome: 'Werner syndrome',
            // ___Cockayne_syndrome: 'Cockayne syndrome',
            ___Truncus_arteriosus_communis: 'Truncus arteriosus communis',
            ___Corrected_transposition_of_great_arteries: 'Corrected transposition of great arteries',
            ___Complete_transposition_of_the_great_arteries: 'Complete transposition of the great arteries',
            ___Hypoplastic_left_heart_syndrome: 'Hypoplastic left heart syndrome',
            ___Tetralogy_of_Fallot: 'Tetralogy of Fallot',
            ___Double_outlet_right_ventricle: 'Double outlet right ventricle',
            ___Ebsteins_anomaly: 'Ebstein\'s anomaly',
            ___Galloway_Mowat_syndrome: 'Galloway-Mowat syndrome',
            ___Primary_nephrotic_syndrome: 'Primary nephrotic syndrome',
            ___Primary_membranoproliferative_glomerulonephritis: 'Primary membranoproliferative glomerulonephritis',
            // ___Alveolar_hypoventilation_syndrome: 'Alveolar hypoventilation syndrome',
            ___Alpha_1_antitrypsin_deficiency: 'Alpha-1-antitrypsin deficiency',
            ___Hypoparathyroidism: 'Hypoparathyroidism',
            // ___Pseudohypoparathyroidism: 'Pseudohypoparathyroidism',
            ___Vitamin_D_resistant_rickets_Vitamin_D_resistant_osteomalacia: 'Vitamin D-resistant rickets/Vitamin D-resistant osteomalacia',
            ___Tyrosinemia_type_1: 'Tyrosinemia type 1',
            ___Tyrosinemia_type_2: 'Tyrosinemia type 2',
            ___Tyrosinemia_type_3: 'Tyrosinemia type 3',
            // ___Galactose_1_phosphate_uridyltransferase_deficiency: 'Galactose-1-phosphate uridyltransferase deficiency',
            ___Lecithin_cholesterol_acyltransferase_deficiency: 'Lecithin cholesterol acyltransferase deficiency',
            // ___Sitosterolemia: 'Sitosterolemia',
            ___Cerebrotendinous_xanthomatosis: 'Cerebrotendinous xanthomatosis',
            ___Chronic_recurrent_multifocal_osteomyelitis: 'Chronic recurrent multifocal osteomyelitis',
            ___Ankylosing_spondylitis: 'Ankylosing spondylitis',
            ___Fibrodysplasia_ossificans_progressiva: 'Fibrodysplasia ossificans progressiva',
            ___Congenital_scoliosis_with_rib_anomalies: 'Congenital scoliosis with rib anomalies',
            ___Giant_lymphatic_malformation_cervicofacial_lesion: 'Giant lymphatic malformation (cervicofacial lesion)',
            ___Giant_venous_malformation_cervical_oral_and_oropharyngeal_diffuse_lesion: 'Giant venous malformation (cervical, oral and oropharyngeal diffuse lesion)',
            ___Klippel_Trenaunay_Weber_syndrome: 'Klippel-Trenaunay-Weber syndrome',
            // ___Diamond_Blackfan_anemia: 'Diamond-Blackfan anemia',
            ___Hirschsprung_disease: 'Hirschsprung disease',
            ___Congenital_diaphragmatic_hernia: 'Congenital diaphragmatic hernia',
            ___Biliary_atresia: 'Biliary atresia',
            ___Macular_dystrophy: 'Macular dystrophy',
            // ___Progressive_leukoencephalopathy: 'Progressive leukoencephalopathy',
            ___Anterior_segment_dysgenesis: 'Anterior segment dysgenesis',
            // ___Aniridia: 'Aniridia',
            ___Idiopathic_multicentric_Castlemans_disease: 'Idiopathic multicentric Castleman\'s disease',
            ___Gelatinous_drop_like_corneal_dystrophy: 'Gelatinous drop-like corneal dystrophy',
            ___MECP2_Duplication_Syndrome: 'MECP2 Duplication Syndrome',
            ___Autosomal_Dominant_Adult_Onset_Demyelinating_Leukodystrophy: 'Autosomal Dominant Adult-Onset Demyelinating Leukodystrophy',
            ___PURA_related_severe_neonatal_hypotonia_seizures_encephalopathy_syndrome: 'PURA-related severe neonatal hypotonia-seizures-encephalopathy syndrome',
            ___very_long_chain_acyl_CoA_dehydrogenase: 'very long-chain acyl-CoA dehydrogenase',
            // ___STING_stimulator_of_interferon_genes_associated_vasculopathy_with_onset_in_infancy: 'STING (stimulator of interferon genes)-associated vasculopathy with onset in infancy',
            ___Bleeding_disorder_with_abnormal_fibrinolysis: 'Bleeding disorder with abnormal fibrinolysis',
            ___Lowe_syndrome: 'Lowe syndrome'
          }
        },
        workgroupRoleOptions: {
          title: {
            ___owner: 'Owner',
            ___director: 'Director',
            ___member: 'Member'
          }
        },
        reportPreviewOptions: {
          categoryTitle: {
            ___AlleleFrequency: 'Allele Frequency',
            ___coverage: 'Coverage',
            ___psSpliceSite: 'Splice Site',
            ___psFunctionPrediction: 'Function Prediction',
            ___psEnsemble: 'Ensemble',
            ___psConservation: 'Conservation',
            ___psgnomADConstraint: 'gnomAD Constraint'
          },
          groupTitle: {
            ___1000Genomes: '1000 Genomes',
            ___gnomADExomes: 'gnomAD Exomes',
            ___gnomADGenomes: 'gnomAD Genomes',
            ___phenoVarDBPrivate: 'PhenoVarDB Private',
            ___phenoVarDBCommunity: 'PhenoVarDB Community',
            ___phenoVarDBAdmin: 'PhenoVarDB Admin',
            ___other: 'Other',
            ___coverageGnomADExomes: 'gnomAD Exomes',
            ___coverageGnomADGenomes: 'gnomAD Genomes'
          },
          linkTitle: {
            ___SpliceAI: 'Click here to look up SpliceAI scores'
          },
          title: {
            ___KG_AF: 'AF',
            ___KG_EAS_AF: 'EAS AF',
            ___KG_AMR_AF: 'AMR AF',
            ___KG_AFR_AF: 'AFR AF',
            ___KG_EUR_AF: 'EUR AF',
            ___KG_SAS_AF: 'SAS AF',
            ___gnomAD_AF: 'AF',
            ___gnomAD_AFR_AF: 'AFR AF',
            ___gnomAD_AMR_AF: 'AMR AF',
            ___gnomAD_ASJ_AF: 'ASJ AF',
            ___gnomAD_EAS_AF: 'EAS AF',
            ___gnomAD_FIN_AF: 'FIN AF',
            ___gnomAD_NFE_AF: 'NFE AF',
            ___gnomAD_OTH_AF: 'OTH AF',
            ___gnomAD_SAS_AF: 'SAS AF',
            ___gnomAD_MID_AF: 'MID AF',
            ___gnomAD_g_AF: 'AF',
            ___gnomAD_g_AF_afr: 'AFR AF',
            ___gnomAD_g_AF_ami: 'AMI AF',
            ___gnomAD_g_AF_amr: 'AMR AF',
            ___gnomAD_g_AF_asj: 'ASJ AF',
            ___gnomAD_g_AF_eas: 'EAS AF',
            ___gnomAD_g_AF_fin: 'FIN AF',
            ___gnomAD_g_AF_mid: 'MID AF',
            ___gnomAD_g_AF_nfe: 'NFE AF',
            ___gnomAD_g_AF_oth: 'OTH AF',
            ___gnomAD_g_AF_sas: 'SAS AF',
            ___gnomAD_g_mt_AF_het: 'Heteroplasmy AF',
            ___gnomAD_g_mt_pop_AF_het_afr: 'Heteroplasmy AFR AF',
            ___gnomAD_g_mt_pop_AF_het_ami: 'Heteroplasmy AMI AF',
            ___gnomAD_g_mt_pop_AF_het_amr: 'Heteroplasmy AMR AF',
            ___gnomAD_g_mt_pop_AF_het_asj: 'Heteroplasmy ASJ AF',
            ___gnomAD_g_mt_pop_AF_het_eas: 'Heteroplasmy EAS AF',
            ___gnomAD_g_mt_pop_AF_het_fin: 'Heteroplasmy FIN AF',
            ___gnomAD_g_mt_pop_AF_het_mid: 'Heteroplasmy MID AF',
            ___gnomAD_g_mt_pop_AF_het_nfe: 'Heteroplasmy NFE AF',
            ___gnomAD_g_mt_pop_AF_het_oth: 'Heteroplasmy OTH AF',
            ___gnomAD_g_mt_pop_AF_het_sas: 'Heteroplasmy SAS AF',
            ___gnomAD_g_mt_AF_hom: 'Homoplasmy AF',
            ___gnomAD_g_mt_pop_AF_hom_afr: 'Homoplasmy AFR AF',
            ___gnomAD_g_mt_pop_AF_hom_ami: 'Homoplasmy AMI AF',
            ___gnomAD_g_mt_pop_AF_hom_amr: 'Homoplasmy AMR AF',
            ___gnomAD_g_mt_pop_AF_hom_asj: 'Homoplasmy ASJ AF',
            ___gnomAD_g_mt_pop_AF_hom_eas: 'Homoplasmy EAS AF',
            ___gnomAD_g_mt_pop_AF_hom_fin: 'Homoplasmy FIN AF',
            ___gnomAD_g_mt_pop_AF_hom_mid: 'Homoplasmy MID AF',
            ___gnomAD_g_mt_pop_AF_hom_nfe: 'Homoplasmy NFE AF',
            ___gnomAD_g_mt_pop_AF_hom_oth: 'Homoplasmy OTH AF',
            ___gnomAD_g_mt_pop_AF_hom_sas: 'Homoplasmy SAS AF',
            ___PVDB_P_FILTER: 'Filter',
            ___PVDB_P_F_MISSING: 'Missing rate',
            ___PVDB_P_AC: 'AC',
            ___PVDB_P_AN: 'AN',
            ___PVDB_P_AF: 'AF',
            ___PVDB_P_DP: 'DP',
            ___PVDB_P_AC_Het: 'AC in heterozygous genotypes',
            ___PVDB_P_AC_Hom: 'AC in homozygous genotypes',
            ___PVDB_P_AC_Hemi: 'AC in hemizygous genotypes',
            ___PVDB_S_FILTER: 'Filter',
            ___PVDB_S_F_MISSING: 'Missing rate',
            ___PVDB_S_AC: 'AC',
            ___PVDB_S_AN: 'AN',
            ___PVDB_S_AF: 'AF',
            ___PVDB_S_DP: 'DP',
            ___PVDB_S_AC_Het: 'AC in heterozygous genotypes',
            ___PVDB_S_AC_Hom: 'AC in homozygous genotypes',
            ___PVDB_S_AC_Hemi: 'AC in hemizygous genotypes',
            ___PVDB_A_FILTER: 'Filter',
            ___PVDB_A_F_MISSING: 'Missing rate',
            ___PVDB_A_AC: 'AC',
            ___PVDB_A_AN: 'AN',
            ___PVDB_A_AF: 'AF',
            ___PVDB_A_DP: 'DP',
            ___PVDB_A_AC_Het: 'AC in heterozygous genotypes',
            ___PVDB_A_AC_Hom: 'AC in homozygous genotypes',
            ___PVDB_A_AC_Hemi: 'AC in hemizygous genotypes',
            ___ESP6500_AF: 'ESP6500 AF',
            ___ESP6500_AA_AF: 'ESP6500 AA',
            ___ESP6500_EA_AF: 'ESP6500 EA',
            ___TW_AF: 'Taiwan Biobank AF',
            ___TOPMED_AF: 'TOPMED AF',
            ___UK10K_AF: 'UK10K AF',
            ___ChinaMAP_AF: 'ChinaMAP AF',
            ___GA_AF: 'Genome Asia100 AF',
            ___KJ_AF: '4.7KJPN AF',
            ___ExAC_AF: 'ExAC AF',
            ___tommo_60kjpn_AF: 'ToMMo 60K JPN AF',
            ___tommo_60kjpn_AN: 'ToMMo 60K JPN AN',
            ___gnomAD_cov_MEAN: 'Mean',
            ___gnomAD_cov_MEDIAN: ' Median',
            ___gnomAD_cov_PCT_20X: '>20x coverage (%)',
            ___gnomAD_g_cov_MEAN: 'Mean',
            ___gnomAD_g_cov_MEDIAN: 'Median',
            ___gnomAD_g_cov_PCT_20X: '>20x coverage (%)',
            ___Alphamissense_score: 'Alphamissense score',
            ___Alphamissense_class: 'Alphamissense class',
            ___SIFT4G_score: 'SIFT4G score',
            ___SIFT4G_pred: 'SIFT4G pred',
            ___Polyphen: 'Polyphen-2 HDIV',
            ___Polyphen_pred: 'Polyphen-2 HDIV pred',
            ___FATHMM_score: 'FATHMM score',
            ___FATHMM_pred: 'FATHMM pred',
            ___PROVEAN_score: 'PROVEAN score',
            ___PROVEAN_pred: 'PROVEAN pred',
            ___CADD_phred: 'CADD phred',
            ___CADD_phred_pred: 'CADD phred pred',
            ___MetaLR_score: 'MetaLR score',
            ___MetaLR_pred: 'MetaLR pred',
            ___MetaSVM_score: 'MetaSVM score',
            ___MetaSVM_pred: 'MetaSVM pred',
            ___REVEL_score: 'REVEL score',
            ___REVEL_pred: 'REVEL pred',
            ___BayesDel_noAF_score: 'BayesDel noAF score',
            ___BayesDel_noAF_pred: 'BayesDel noAF pred',
            ___gnomAD_g_mt_mitotip_score: 'MitoTip score',
            ___gnomAD_g_mt_mitotip_score_pred: 'MitoTip pred',
            ___ada_score: 'ada score',
            ___ada_pred: 'ada pred',
            ___rf_score: 'rf score',
            ___rf_pred: 'rf pred',
            ___CI_SpliceAI_DS_AG: 'CI-SpliceAI DS AG',
            ___CI_SpliceAI_DS_AL: 'CI-SpliceAI DS AL',
            ___CI_SpliceAI_DS_DG: 'CI-SpliceAI DS DG',
            ___CI_SpliceAI_DS_DL: 'CI-SpliceAI DS DL',
            ___CI_SpliceAI_DP_AG: 'CI-SpliceAI DP AG',
            ___CI_SpliceAI_DP_AL: 'CI-SpliceAI DP AL',
            ___CI_SpliceAI_DP_DG: 'CI-SpliceAI DP DG',
            ___CI_SpliceAI_DP_DL: 'CI-SpliceAI DP DL',
            ___SpliceAI: 'SpliceAI',
            ___SpliceAI_DS_AG: 'SpliceAI Acceptor gain score',
            ___SpliceAI_DS_AL: 'SpliceAI Acceptor loss score',
            ___SpliceAI_DS_DG: 'SpliceAI Donor gain score',
            ___SpliceAI_DS_DL: 'SpliceAI Donor loss score',
            ___SpliceAI_DP_AG: 'SpliceAI Acceptor gain position',
            ___SpliceAI_DP_AL: 'SpliceAI Acceptor loss position',
            ___SpliceAI_DP_DG: 'SpliceAI Donor gain position',
            ___SpliceAI_DP_DL: 'SpliceAI Donor loss positon',
            ___GERPpp_NR: 'GERP++NR',
            ___GERPpp_RS: 'GERP++RS',
            ___GERPpp_RS_pred: 'GERP++RS pred',
            ___SiPhy_29way_logOdds: 'SiPhy 29way logOdds',
            ___SiPhy_29way_logOdds_pred: 'SiPhy 29way logOdds pred',
            ___SiPhy_29way_pi: 'SiPhy 29way pi',
            ___oe_syn: 'Synonymous o/e',
            ___oe_mis: 'Missense o/e',
            ___oe_lof: 'pLoF o/e',
            ___syn_z: 'Synonymous z-score',
            ___mis_z: 'Missense z-score',
            ___pLI: 'pLI'
          }
        },
        licenseStatusMap: {
          title: {
            ___inactive: 'Inactive',
            ___active: 'Active',
            ___exceeded: 'Exceeded',
            ___expired: 'Expired',
            ___unlimited: 'Unlimited'
          }
        },
        licenseApiMap: {
          title: {
            ___vcf_analysis: 'VCF Analysis',
            ___fastq_analysis: 'FASTQ Analysis',
            ___report_module: 'Report Module',
            ___mastermind: 'Mastermind'
          }
        }
      }
    }
  },
  // common
  COMMON: {
    button: {
      ___add: 'Add',
      ___select: 'Select',
      ___export: 'Export',
      ___hideDeleted: 'Hide deleted',
      ___showDeleted: 'Show deleted',
      ___reset: 'Reset',
      ___apply: 'Apply',
      ___generate: 'Generate',
      ___regenerate: 'Regenerate',
      ___createUrl: 'Create URL',
      ___search: 'Search',
      ___cancel: 'Cancel',
      ___create: 'Create',
      ___return: 'Return',
      ___update: 'Update',
      ___archive: 'Archive',
      ___delete: 'Delete',
      ___leave: 'Leave',
      ___shareSetting: 'Share setting',
      ___accept: 'Accept',
      ___addAll: 'Add all',
      ___save: 'Save',
      ___confirm: 'Confirm',
      ___enter: 'Enter',
      ___import: 'Import',
      ___reanalysis: 'Reanalysis',
      ___vcf: 'VCF',
      ___fastq: 'fastq',
      ___upload: 'Upload',
      ___newChapter: 'New Section',
      ___newCNV: 'New CNV',
      ___newWorkgroup: 'New Group',
      ___newConfig: 'New Config',
      ___addMember: 'Add Member',
      ___addCases: 'Add Cases',
      ___addStage: 'Add Stage',
      ___newPanel: 'New Panel',
      ___newAnalysis: 'New Analysis',
      ___submit: 'Submit',
      ___hideArchives: 'Hide archives',
      ___showArchives: 'Show archives',
      ___active: 'Active',
      ___send: 'Send',
      ___ignore: 'Ignore',
      ___login: 'Login',
      ___signUp: 'Sign Up',
      ___backToSearch: 'Back to Search',
      ___buyMore: 'Buy more',
      ___contactUs: 'Contact us',
      ___verify: 'Verify',
      ___change: 'Change',
      ___proceed: 'Proceed',
      ___set: 'Set',
      ___retry: 'Retry',
      ___stop: 'Stop',
      ___date: 'Date',
      ___none: 'None',
      ___yes: 'Yes',
      ___no: 'No',
      ___unlock: 'Unlock'
    },
    toast: {
      ___licenseInvalid: 'License ID is invalid.',
      ___licenseExceeded: 'Function usage limit exceeded.',
      ___licenseExpired: 'License is expired.',
      ___noPermission: 'No permission',
      ___pleaseLogin: 'Please login',
      ___xhrCanNotUpload: 'Xhr can not upload.',
      ___pleaseAgreeTerms: 'Please agree terms',
      ___phenotypesAnalyzeLimit: 'More than {amount} phenotypes cannot be analyzed.',
      ___datasetReachLimit: 'Datasets have reached the maximum capacity.',
      ___analysisTimeout: 'Analysis timeout has been notified to relevant personnel.',
      ___wrongFiles: 'Wrong Files',
      ___getSignUrlFailed: 'Get sign url failed.',
      ___addSameHPOTerm: 'You have added a HPO term with the same HPO identity.',
      ___geneSymbolInvalidFormat: 'Invalid format for gene symbol or entrezid.',
      ___fileTypeAlert: 'The file format is invalid. Please upload a file in {types} format.',
      ___variantInAllChapter: 'This variant has been added to all the sections.',
      ___noPermissionToOpenDataset: 'You have no permission to open this dataset.',
      ___reportUpdated: 'The report is updated.',
      ___tsvExportLimit: 'TSV export limit to {amount} records.',
      ___atLeastOneCardOpen: 'At least one card should be left open.',
      ___noPermissionToUploadFile: 'You have no permission to upload the file.',
      ___snvFileRequired: 'snv file should not be empty.',
      ___dataShouldBePaired: 'The data should be paired, please check you file numbers.',
      ___sampleFamilyAnalysis: 'This sample is temporarily protected owing to the sample usage of family analysis.',
      ___familyMemberLimit: 'The numberof selected members can not be greater than {limit}.',
      ___workgroupLimit: 'The max number of groups is {limit} and has reached its limit.',
      ___workgroupMemberExist: 'The member has been exist in the group.',
      ___addWorkgroupMember: 'A member has been added successfully.',
      ___editWorkgroupMember: 'A member has been updated successfully.',
      ___addWorkgroupCase: '{count} case has been added successfully. | {count} cases have been added successfully.',
      ___addWorkgroupCaseAutoShare: '{count} case has been added successfully. Auto-share has been enabled, and your future uploaded cases will be automatically shared with this workgroup. | {count} cases have been added successfully. Auto-share has been enabled, and your future uploaded cases will be automatically shared with this workgroup.',
      ___workgroupStageLimit: 'The max number of stage is {limit} and has reached its limit.',
      ___workgroupStageExist: 'The stage has been exist in the group.',
      ___addWorkgroupStage: 'A stage has been added successfully.',
      ___editWorkgroupStage: 'A stage has been updated successfully.',
      ___batchExpired: 'Due to the batch, <b>created at {created}</b>, <span style="color:#FA3D3D">has not been edited for more than 5 days</span>, all records,<br>including the VCF and sample sheet file, has been deleted. Please create a new batch again.',
      ___exportCaseReport: 'The password to open the report is your account email.',
      ___fileUploadLimit: 'You can upload a maximum of {count} files.',
      ___genePanelItemExist: 'The selected {type} has already been added.',
      ___mastermindLicense: 'Unlock insights by purchasing a Mastermind license or contacting your sales representative.'
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/lang/en/lang.js